import { EntityTypes } from '../../constants';

export const SET_FACEBOOK_AUTH = 'SET_FACEBOOK_AUTH';
export type SET_FACEBOOK_AUTH = typeof SET_FACEBOOK_AUTH;

export const SIGN_OUT = 'SIGN_OUT';
export type SIGN_OUT = typeof SIGN_OUT;

export const INCREMENT_ENTHUSIASM = 'INCREMENT_ENTHUSIASM';
export type INCREMENT_ENTHUSIASM = typeof INCREMENT_ENTHUSIASM;

export const DECREMENT_ENTHUSIASM = 'DECREMENT_ENTHUSIASM';
export type DECREMENT_ENTHUSIASM = typeof DECREMENT_ENTHUSIASM;

export const SET_NAME = 'SET_NAME';
export type SET_NAME = typeof SET_NAME;

export const SET_BOARD = 'SET_BOARD';
export type SET_BOARD = typeof SET_BOARD;

export const SET_COMPETITION = 'SET_COMPETITION';
export type SET_COMPETITION = typeof SET_COMPETITION;

export const SET_USER = 'SET_USER';
export type SET_USER = typeof SET_USER;

export const ADD_FOLDER = 'ADD_FOLDER';
export type ADD_FOLDER = typeof ADD_FOLDER;

export const REMOVE_FOLDER = 'REMOVE_FOLDER';
export type REMOVE_FOLDER = typeof REMOVE_FOLDER;

export const BOARD_BLOCK_USERNAME = 'BOARD_BLOCK_USERNAME';
export type BOARD_BLOCK_USERNAME = typeof BOARD_BLOCK_USERNAME;

export const REMOVE_BLOCKED_USER_STORIES = 'REMOVE_BLOCKED_USER_STORIES';
export type REMOVE_BLOCKED_USER_STORIES = typeof REMOVE_BLOCKED_USER_STORIES;

export const ADD_CUSTOM_LINK = 'ADD_CUSTOM_LINK';
export type ADD_CUSTOM_LINK = typeof ADD_CUSTOM_LINK;

export const ADD_ALT_TEXT = 'ADD_ALT_TEXT';
export type ADD_ALT_TEXT = 'ADD_ALT_TEXT';

export const BOARD_UNBLOCK_USERNAME = 'BOARD_UNBLOCK_USERNAME';
export type BOARD_UNBLOCK_USERNAME = typeof BOARD_UNBLOCK_USERNAME;

export const SET_USER_SETTING = 'SET_USER_SETTING';
export type SET_USER_SETTING = typeof SET_USER_SETTING;

export const SET_BOARD_HASHTAG_IMAGE = 'SET_BOARD_HASHTAG_IMAGE';
export type SET_BOARD_HASHTAG_IMAGE = typeof SET_BOARD_HASHTAG_IMAGE;

export const REMOVE_KEYWORD_REQUEST = 'REMOVE_KEYWORD_REQUEST';
export type REMOVE_KEYWORD_REQUEST = typeof REMOVE_KEYWORD_REQUEST;

export const REMOVE_KEYWORD_SUCCESS = 'REMOVE_KEYWORD_SUCCESS';
export type REMOVE_KEYWORD_SUCCESS = typeof REMOVE_KEYWORD_SUCCESS;

export const REMOVE_KEYWORD_FAILURE = 'REMOVE_KEYWORD_FAILURE';
export type REMOVE_KEYWORD_FAILURE = typeof REMOVE_KEYWORD_FAILURE;

export const SET_KEYWORDS = 'SET_KEYWORDS';
export type SET_KEYWORDS = typeof SET_KEYWORDS;

export const ADD_KEYWORD = 'ADD_KEYWORD';
export type ADD_KEYWORD = typeof ADD_KEYWORD;

export const ADD_KEYWORD_REQUEST = 'ADD_KEYWORD_REQUEST';
export type ADD_KEYWORD_REQUEST = typeof ADD_KEYWORD_REQUEST;

export const ADD_KEYWORD_SUCCESS = 'ADD_KEYWORD_SUCCESS';
export type ADD_KEYWORD_SUCCESS = typeof ADD_KEYWORD_SUCCESS;

export const ADD_KEYWORD_FAILURE = 'ADD_KEYWORD_FAILURE';
export type ADD_KEYWORD_FAILURE = typeof ADD_KEYWORD_FAILURE;

export const NEW_INBOX_REMOVE_KEYWORD_REQUEST = 'NEW_INBOX_REMOVE_KEYWORD_REQUEST';
export type NEW_INBOX_REMOVE_KEYWORD_REQUEST = typeof NEW_INBOX_REMOVE_KEYWORD_REQUEST;

export const NEW_INBOX_REMOVE_KEYWORD_SUCCESS = 'NEW_INBOX_REMOVE_KEYWORD_SUCCESS';
export type NEW_INBOX_REMOVE_KEYWORD_SUCCESS = typeof NEW_INBOX_REMOVE_KEYWORD_SUCCESS;

export const NEW_INBOX_REMOVE_KEYWORD_FAILURE = 'NEW_INBOX_REMOVE_KEYWORD_FAILURE';
export type NEW_INBOX_REMOVE_KEYWORD_FAILURE = typeof NEW_INBOX_REMOVE_KEYWORD_FAILURE;

export const NEW_INBOX_ADD_KEYWORD_REQUEST = 'NEW_INBOX_ADD_KEYWORD_REQUEST';
export type NEW_INBOX_ADD_KEYWORD_REQUEST = typeof NEW_INBOX_ADD_KEYWORD_REQUEST;

export const NEW_INBOX_ADD_KEYWORD_SUCCESS = 'NEW_INBOX_ADD_KEYWORD_SUCCESS';
export type NEW_INBOX_ADD_KEYWORD_SUCCESS = typeof NEW_INBOX_ADD_KEYWORD_SUCCESS;

export const NEW_INBOX_ADD_KEYWORD_FAILURE = 'NEW_INBOX_ADD_KEYWORD_FAILURE';
export type NEW_INBOX_ADD_KEYWORD_FAILURE = typeof NEW_INBOX_ADD_KEYWORD_FAILURE;

export const SET_AUTH_STATE = 'SET_AUTH_STATE';
export type SET_AUTH_STATE = typeof SET_AUTH_STATE;

export const SET_STORIES = 'SET_STORIES';
export type SET_STORIES = typeof SET_STORIES;

export const SET_RECOMMENDED_STORIES = 'SET_RECOMMENDED_STORIES';
export type SET_RECOMMENDED_STORIES = typeof SET_RECOMMENDED_STORIES;

export const DISMISS_RECOMMENDED_STORIES = 'DISMISS_RECOMMENDED_STORIES';
export type DISMISS_RECOMMENDED_STORIES = typeof DISMISS_RECOMMENDED_STORIES;

export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export type SET_SEARCH_QUERY = typeof SET_SEARCH_QUERY;

export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS';
export type SET_SEARCH_FILTERS = typeof SET_SEARCH_FILTERS;

export const SET_SEARCH_ALL = 'SET_SEARCH_ALL';
export type SET_SEARCH_ALL = typeof SET_SEARCH_ALL;

export const SET_LAST_QUERY = 'SET_LAST_QUERY';
export type SET_LAST_QUERY = typeof SET_LAST_QUERY;

export const SHOW_REFRESH_BUTTON = 'SHOW_REFRESH_BUTTON';
export type SHOW_REFRESH_BUTTON = typeof SHOW_REFRESH_BUTTON;

export const GET_FOLDER = 'GET_FOLDER';
export type GET_FOLDER = typeof GET_FOLDER;

export const ADD_STORY_TO_FOLDER = 'ADD_STORY_TO_FOLDER';
export type ADD_STORY_TO_FOLDER = typeof ADD_STORY_TO_FOLDER;

export const REMOVE_STORY_FROM_FOLDER = 'REMOVE_STORY_FROM_FOLDER';
export type REMOVE_STORY_FROM_FOLDER = typeof REMOVE_STORY_FROM_FOLDER;

export const INCREMENT_PINNED_COUNT = 'INCREMENT_PINNED_COUNT';
export type INCREMENT_PINNED_COUNT = typeof INCREMENT_PINNED_COUNT;

export const DECREMENT_PINNED_COUNT = 'DECREMENT_PINNED_COUNT';
export type DECREMENT_PINNED_COUNT = typeof DECREMENT_PINNED_COUNT;

export const MARK_STORY_READ = 'MARK_STORY_READ';
export type MARK_STORY_READ = typeof MARK_STORY_READ;

export const PIN_STORY = 'PIN_STORY';
export type PIN_STORY = typeof PIN_STORY;

export const DELETE_STORY = 'DELETE_STORY';
export type DELETE_STORY = typeof DELETE_STORY;

export const MOVE_STORY = 'MOVE_STORY';
export type MOVE_STORY = typeof MOVE_STORY;

export const GET_RECOMMENDED_STORIES = 'GET_RECOMMENDED_STORIES';
export type GET_RECOMMENDED_STORIES = typeof GET_RECOMMENDED_STORIES;

export const GET_STORIES_REQUEST = 'GET_STORIES_REQUEST';
export type GET_STORIES_REQUEST = typeof GET_STORIES_REQUEST;

export const GET_STORIES_SUCCESS = 'GET_STORIES_SUCCESS';
export type GET_STORIES_SUCCESS = typeof GET_STORIES_SUCCESS;

export const GET_STORIES_FAILURE = 'GET_STORIES_FAILURE';
export type GET_STORIES_FAILURE = typeof GET_STORIES_FAILURE;

export const CLEAR_STORIES = 'CLEAR_STORIES';
export type CLEAR_STORIES = typeof CLEAR_STORIES;

export const GET_RECOMMENDED_STORIES_REQUEST = 'GET_RECOMMENDED_STORIES_REQUEST';
export type GET_RECOMMENDED_STORIES_REQUEST = typeof GET_RECOMMENDED_STORIES_REQUEST;

export const GET_RECOMMENDED_STORIES_SUCCESS = 'GET_RECOMMENDED_STORIES_SUCCESS';
export type GET_RECOMMENDED_STORIES_SUCCESS = typeof GET_RECOMMENDED_STORIES_SUCCESS;

export const GET_RECOMMENDED_STORIES_FAILURE = 'GET_RECOMMENDED_STORIES_FAILURE';
export type GET_RECOMMENDED_STORIES_FAILURE = typeof GET_RECOMMENDED_STORIES_FAILURE;

export const SET_ENTITIES = 'SET_ENTITIES';
export type SET_ENTITIES = typeof SET_ENTITIES;

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export type UPDATE_USER_REQUEST = typeof UPDATE_USER_REQUEST;

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export type UPDATE_USER_SUCCESS = typeof UPDATE_USER_SUCCESS;

export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export type UPDATE_USER_FAILURE = typeof UPDATE_USER_FAILURE;

export const UPDATE_BOARD_REQUEST = 'UPDATE_BOARD_REQUEST';
export type UPDATE_BOARD_REQUEST = typeof UPDATE_BOARD_REQUEST;

export const UPDATE_BOARD_SUCCESS = 'UPDATE_BOARD_SUCCESS';
export type UPDATE_BOARD_SUCCESS = typeof UPDATE_BOARD_SUCCESS;

export const UPDATE_BOARD_FAILURE = 'UPDATE_BOARD_FAILURE';
export type UPDATE_BOARD_FAILURE = typeof UPDATE_BOARD_FAILURE;

export const UPDATE_ORG_MEMBER_ROLE_REQUEST = 'UPDATE_ORG_MEMBER_ROLE_REQUEST';
export type UPDATE_ORG_MEMBER_ROLE_REQUEST = typeof UPDATE_ORG_MEMBER_ROLE_REQUEST;

export const UPDATE_ORG_MEMBER_ROLE_SUCCESS = 'UPDATE_ORG_MEMBER_ROLE_SUCCESS';
export type UPDATE_ORG_MEMBER_ROLE_SUCCESS = typeof UPDATE_ORG_MEMBER_ROLE_SUCCESS;

export const UPDATE_ORG_MEMBER_ROLE_FAILURE = 'UPDATE_ORG_MEMBER_ROLE_FAILURE';
export type UPDATE_ORG_MEMBER_ROLE_FAILURE = typeof UPDATE_ORG_MEMBER_ROLE_FAILURE;

export const GET_MEMBER_LIST_REQUEST = 'GET_MEMBER_LIST_REQUEST';
export type GET_MEMBER_LIST_REQUEST = typeof GET_MEMBER_LIST_REQUEST;

export const GET_MEMBER_LIST_SUCCESS = 'GET_MEMBER_LIST_SUCCESS';
export type GET_MEMBER_LIST_SUCCESS = typeof GET_MEMBER_LIST_SUCCESS;

export const GET_MEMBER_LIST_FAILURE = 'GET_MEMBER_LIST_FAILURE';
export type GET_MEMBER_LIST_FAILURE = typeof GET_MEMBER_LIST_FAILURE;

export const REMOVE_ORG_USER_REQUEST = 'REMOVE_ORG_USER_REQUEST';
export type REMOVE_ORG_USER_REQUEST = typeof REMOVE_ORG_USER_REQUEST;

export const REMOVE_ORG_USER_SUCCESS = 'REMOVE_ORG_USER_SUCCESS';
export type REMOVE_ORG_USER_SUCCESS = typeof REMOVE_ORG_USER_SUCCESS;

export const REMOVE_ORG_USER_FAILURE = 'REMOVE_ORG_USER_FAILURE';
export type REMOVE_ORG_USER_FAILURE = typeof REMOVE_ORG_USER_FAILURE;

export const GET_BOARD_MEMBER_LIST_REQUEST = 'GET_BOARD_MEMBER_LIST_REQUEST';
export type GET_BOARD_MEMBER_LIST_REQUEST = typeof GET_BOARD_MEMBER_LIST_REQUEST;

export const GET_BOARD_MEMBER_LIST_SUCCESS = 'GET_BOARD_MEMBER_LIST_SUCCESS';
export type GET_BOARD_MEMBER_LIST_SUCCESS = typeof GET_BOARD_MEMBER_LIST_SUCCESS;

export const GET_BOARD_MEMBER_LIST_FAILURE = 'GET_BOARD_MEMBER_LIST_FAILURE';
export type GET_BOARD_MEMBER_LIST_FAILURE = typeof GET_BOARD_MEMBER_LIST_FAILURE;

export const UPDATE_BOARD_MEMBER_ROLE_REQUEST = 'UPDATE_BOARD_MEMBER_ROLE_REQUEST';
export type UPDATE_BOARD_MEMBER_ROLE_REQUEST = typeof UPDATE_BOARD_MEMBER_ROLE_REQUEST;

export const UPDATE_BOARD_MEMBER_ROLE_SUCCESS = 'UPDATE_BOARD_MEMBER_ROLE_SUCCESS';
export type UPDATE_BOARD_MEMBER_ROLE_SUCCESS = typeof UPDATE_BOARD_MEMBER_ROLE_SUCCESS;

export const UPDATE_BOARD_MEMBER_ROLE_FAILURE = 'UPDATE_BOARD_MEMBER_ROLE_FAILURE';
export type UPDATE_BOARD_MEMBER_ROLE_FAILURE = typeof UPDATE_BOARD_MEMBER_ROLE_FAILURE;

export const REMOVE_BOARD_MEMBER_REQUEST = 'REMOVE_BOARD_MEMBER_REQUEST';
export type REMOVE_BOARD_MEMBER_REQUEST = typeof REMOVE_BOARD_MEMBER_REQUEST;

export const REMOVE_BOARD_MEMBER_SUCCESS = 'REMOVE_BOARD_MEMBER_SUCCESS';
export type REMOVE_BOARD_MEMBER_SUCCESS = typeof REMOVE_BOARD_MEMBER_SUCCESS;

export const REMOVE_BOARD_MEMBER_FAILURE = 'REMOVE_BOARD_MEMBER_FAILURE';
export type REMOVE_BOARD_MEMBER_FAILURE = typeof REMOVE_BOARD_MEMBER_FAILURE;

export const INVITE_ORG_MEMBERS_REQUEST = 'INVITE_ORG_MEMBERS_REQUEST';
export type INVITE_ORG_MEMBERS_REQUEST = typeof INVITE_ORG_MEMBERS_REQUEST;

export const INVITE_ORG_MEMBERS_SUCCESS = 'INVITE_ORG_MEMBERS_SUCCESS';
export type INVITE_ORG_MEMBERS_SUCCESS = typeof INVITE_ORG_MEMBERS_SUCCESS;

export const INVITE_ORG_MEMBERS_FAILURE = 'INVITE_ORG_MEMBERS_FAILURE';
export type INVITE_ORG_MEMBERS_FAILURE = typeof INVITE_ORG_MEMBERS_FAILURE;

export const INVITE_BOARD_MEMBERS_REQUEST = 'INVITE_BOARD_MEMBERS_REQUEST';
export type INVITE_BOARD_MEMBERS_REQUEST = typeof INVITE_BOARD_MEMBERS_REQUEST;

export const INVITE_BOARD_MEMBERS_SUCCESS = 'INVITE_BOARD_MEMBERS_SUCCESS';
export type INVITE_BOARD_MEMBERS_SUCCESS = typeof INVITE_BOARD_MEMBERS_SUCCESS;

export const INVITE_BOARD_MEMBERS_FAILURE = 'INVITE_BOARD_MEMBERS_FAILURE';
export type INVITE_BOARD_MEMBERS_FAILURE = typeof INVITE_BOARD_MEMBERS_FAILURE;

export const CREATE_ORG_REQUEST = 'CREATE_ORG_REQUEST';
export type CREATE_ORG_REQUEST = typeof CREATE_ORG_REQUEST;

export const CREATE_ORG_SUCCESS = 'CREATE_ORG_SUCCESS';
export type CREATE_ORG_SUCCESS = typeof CREATE_ORG_SUCCESS;

export const CREATE_ORG_FAILURE = 'CREATE_ORG_FAILURE';
export type CREATE_ORG_FAILURE = typeof CREATE_ORG_FAILURE;

export const DELETE_BOARD_REQUEST = 'DELETE_BOARD_REQUEST';
export type DELETE_BOARD_REQUEST = typeof DELETE_BOARD_REQUEST;

export const DELETE_BOARD_SUCCESS = 'DELETE_BOARD_SUCCESS';
export type DELETE_BOARD_SUCCESS = typeof DELETE_BOARD_SUCCESS;

export const DELETE_BOARD_FAILURE = 'DELETE_BOARD_FAILURE';
export type DELETE_BOARD_FAILURE = typeof DELETE_BOARD_FAILURE;

export const UPDATE_PAYMENT_INFO_REQUEST = 'UPDATE_PAYMENT_INFO_REQUEST';
export type UPDATE_PAYMENT_INFO_REQUEST = typeof UPDATE_PAYMENT_INFO_REQUEST;

export const UPDATE_PAYMENT_INFO_SUCCESS = 'UPDATE_PAYMENT_INFO_SUCCESS';
export type UPDATE_PAYMENT_INFO_SUCCESS = typeof UPDATE_PAYMENT_INFO_SUCCESS;

export const UPDATE_PAYMENT_INFO_FAILURE = 'UPDATE_PAYMENT_INFO_FAILURE';
export type UPDATE_PAYMENT_INFO_FAILURE = typeof UPDATE_PAYMENT_INFO_FAILURE;

export const ATTACH_PROMO_CODE_REQUEST = 'ATTACH_PROMO_CODE_REQUEST';
export type ATTACH_PROMO_CODE_REQUEST = typeof ATTACH_PROMO_CODE_REQUEST;

export const ATTACH_PROMO_CODE_SUCCESS = 'ATTACH_PROMO_CODE_SUCCESS';
export type ATTACH_PROMO_CODE_SUCCESS = typeof ATTACH_PROMO_CODE_SUCCESS;

export const ATTACH_PROMO_CODE_FAILURE = 'ATTACH_PROMO_CODE_FAILURE';
export type ATTACH_PROMO_CODE_FAILURE = typeof ATTACH_PROMO_CODE_FAILURE;

export const GET_CUSTOMER_REQUEST = 'GET_CUSTOMER_REQUEST';
export type GET_CUSTOMER_REQUEST = typeof GET_CUSTOMER_REQUEST;

export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
export type GET_CUSTOMER_SUCCESS = typeof GET_CUSTOMER_SUCCESS;

export const GET_CUSTOMER_FAILURE = 'GET_CUSTOMER_FAILURE';
export type GET_CUSTOMER_FAILURE = typeof GET_CUSTOMER_FAILURE;
export const ADD_GEOTAG_URL_REQUEST = 'ADD_GEOTAG_URL_REQUEST';
export type ADD_GEOTAG_URL_REQUEST = typeof ADD_GEOTAG_URL_REQUEST;

export const ADD_GEOTAG_URL_SUCCESS = 'ADD_GEOTAG_URL_SUCCESS';
export type ADD_GEOTAG_URL_SUCCESS = typeof ADD_GEOTAG_URL_SUCCESS;

export const ADD_GEOTAG_URL_FAILURE = 'ADD_GEOTAG_URL_FAILURE';
export type ADD_GEOTAG_URL_FAILURE = typeof ADD_GEOTAG_URL_FAILURE;

export const REMOVE_GEOTAG_URL_REQUEST = 'REMOVE_GEOTAG_URL_REQUEST';
export type REMOVE_GEOTAG_URL_REQUEST = typeof REMOVE_GEOTAG_URL_REQUEST;

export const REMOVE_GEOTAG_URL_SUCCESS = 'REMOVE_GEOTAG_URL_SUCCESS';
export type REMOVE_GEOTAG_URL_SUCCESS = typeof REMOVE_GEOTAG_URL_SUCCESS;

export const REMOVE_GEOTAG_URL_FAILURE = 'REMOVE_GEOTAG_URL_FAILURE';
export type REMOVE_GEOTAG_URL_FAILURE = typeof REMOVE_GEOTAG_URL_FAILURE;

export const GET_BOARD_REQUEST = 'GET_BOARD_REQUEST';
export type GET_BOARD_REQUEST = typeof GET_BOARD_REQUEST;

export const GET_BOARD_SUCCESS = 'GET_BOARD_SUCCESS';
export type GET_BOARD_SUCCESS = typeof GET_BOARD_SUCCESS;

export const GET_BOARD_FAILURE = 'GET_BOARD_FAILURE';
export type GET_BOARD_FAILURE = typeof GET_BOARD_FAILURE;

export const CLEAR_ENTITY = 'CLEAR_ENTITY';
export type CLEAR_ENTITY = typeof CLEAR_ENTITY;

export const CREATE_BOARD_REQUEST = 'CREATE_BOARD_REQUEST';
export type CREATE_BOARD_REQUEST = typeof CREATE_BOARD_REQUEST;

export const CREATE_BOARD_SUCCESS = 'CREATE_BOARD_SUCCESS';
export type CREATE_BOARD_SUCCESS = typeof CREATE_BOARD_SUCCESS;

export const CREATE_BOARD_FAILURE = 'CREATE_BOARD_FAILURE';
export type CREATE_BOARD_FAILURE = typeof CREATE_BOARD_FAILURE;

export const GET_ORG_REQUEST = 'GET_ORG_REQUEST';
export type GET_ORG_REQUEST = typeof GET_ORG_REQUEST;

export const GET_ORG_SUCCESS = 'GET_ORG_SUCCESS';
export type GET_ORG_SUCCESS = typeof GET_ORG_SUCCESS;

export const GET_ORG_FAILURE = 'GET_ORG_FAILURE';
export type GET_ORG_FAILURE = typeof GET_ORG_FAILURE;

export const GET_UPCOMING_INVOICE_REQUEST = 'GET_UPCOMING_INVOICE_REQUEST';
export type GET_UPCOMING_INVOICE_REQUEST = typeof GET_UPCOMING_INVOICE_REQUEST;

export const GET_UPCOMING_INVOICE_SUCCESS = 'GET_UPCOMING_INVOICE_SUCCESS';
export type GET_UPCOMING_INVOICE_SUCCESS = typeof GET_UPCOMING_INVOICE_SUCCESS;

export const GET_UPCOMING_INVOICE_FAILURE = 'GET_UPCOMING_INVOICE_FAILURE';
export type GET_UPCOMING_INVOICE_FAILURE = typeof GET_UPCOMING_INVOICE_FAILURE;

export const VALID_URL_REQUEST = 'VALID_URL_REQUEST';
export type VALID_URL_REQUEST = typeof VALID_URL_REQUEST;

export const VALID_URL_SUCCESS = 'VALID_URL_SUCCESS';
export type VALID_URL_SUCCESS = typeof VALID_URL_SUCCESS;

export const VALID_URL_FAILURE = 'VALID_URL_FAILURE';
export type VALID_URL_FAILURE = typeof VALID_URL_FAILURE;

export const GET_BOARD_META_REQUEST = 'GET_BOARD_META_REQUEST';
export type GET_BOARD_META_REQUEST = typeof GET_BOARD_META_REQUEST;

export const GET_BOARD_META_SUCCESS = 'GET_BOARD_META_SUCCESS';
export type GET_BOARD_META_SUCCESS = typeof GET_BOARD_META_SUCCESS;

export const GET_BOARD_META_FAILURE = 'GET_BOARD_META_FAILURE';
export type GET_BOARD_META_FAILURE = typeof GET_BOARD_META_FAILURE;

export const UPDATE_BOARD_EMBED_URL_REQUEST = 'UPDATE_BOARD_EMBED_URL_REQUEST';
export type UPDATE_BOARD_EMBED_URL_REQUEST = typeof UPDATE_BOARD_EMBED_URL_REQUEST;

export const UPDATE_BOARD_EMBED_URL_SUCCESS = 'UPDATE_BOARD_EMBED_URL_SUCCESS';
export type UPDATE_BOARD_EMBED_URL_SUCCESS = typeof UPDATE_BOARD_EMBED_URL_SUCCESS;

export const UPDATE_BOARD_EMBED_URL_FAILURE = 'UPDATE_BOARD_EMBED_URL_FAILURE';
export type UPDATE_BOARD_EMBED_URL_FAILURE = typeof UPDATE_BOARD_EMBED_URL_FAILURE;

export const UPDATE_BOARD_SHARE_MESSAGING_REQUEST = 'UPDATE_BOARD_SHARE_MESSAGING_REQUEST';
export type UPDATE_BOARD_SHARE_MESSAGING_REQUEST = typeof UPDATE_BOARD_SHARE_MESSAGING_REQUEST;

export const UPDATE_BOARD_SHARE_MESSAGING_SUCCESS = 'UPDATE_BOARD_SHARE_MESSAGING_SUCCESS';
export type UPDATE_BOARD_SHARE_MESSAGING_SUCCESS = typeof UPDATE_BOARD_SHARE_MESSAGING_SUCCESS;

export const UPDATE_BOARD_SHARE_MESSAGING_FAILURE = 'UPDATE_BOARD_SHARE_MESSAGING_FAILURE';
export type UPDATE_BOARD_SHARE_MESSAGING_FAILURE = typeof UPDATE_BOARD_SHARE_MESSAGING_FAILURE;

export const SUBMIT_INFLUENCER_PERSONAL_REQUEST = 'SUBMIT_INFLUENCER_PERSONAL_REQUEST';
export type SUBMIT_INFLUENCER_PERSONAL_REQUEST = typeof SUBMIT_INFLUENCER_PERSONAL_REQUEST;

export const SUBMIT_INFLUENCER_PERSONAL_SUCCESS = 'SUBMIT_INFLUENCER_PERSONAL_SUCCESS';
export type SUBMIT_INFLUENCER_PERSONAL_SUCCESS = typeof SUBMIT_INFLUENCER_PERSONAL_SUCCESS;

export const SUBMIT_INFLUENCER_PERSONAL_FAILURE = 'SUBMIT_INFLUENCER_PERSONAL_FAILURE';
export type SUBMIT_INFLUENCER_PERSONAL_FAILURE = typeof SUBMIT_INFLUENCER_PERSONAL_FAILURE;

export const SET_FB_TOKEN_REQUEST = 'SET_FB_TOKEN_REQUEST';
export type SET_FB_TOKEN_REQUEST = typeof SET_FB_TOKEN_REQUEST;

export const SET_FB_TOKEN_SUCCESS = 'SET_FB_TOKEN_SUCCESS';
export type SET_FB_TOKEN_SUCCESS = typeof SET_FB_TOKEN_SUCCESS;

export const SET_FB_TOKEN_FAILURE = 'SET_FB_TOKEN_FAILURE';
export type SET_FB_TOKEN_FAILURE = typeof SET_FB_TOKEN_FAILURE;

export const NEW_INBOX_CLEAR = 'NEW_INBOX_CLEAR';
export type NEW_INBOX_CLEAR = typeof NEW_INBOX_CLEAR;

export const NEW_INBOX_NEXT_STEP = 'NEW_INBOX_NEXT_STEP';
export type NEW_INBOX_NEXT_STEP = typeof NEW_INBOX_NEXT_STEP;

export const NEW_INBOX_PREV_STEP = 'NEW_INBOX_PREV_STEP';
export type NEW_INBOX_PREV_STEP = typeof NEW_INBOX_PREV_STEP;

export const NEW_INBOX_SET_FB_TOKEN_REQUEST = 'NEW_INBOX_SET_FB_TOKEN_REQUEST';
export type NEW_INBOX_SET_FB_TOKEN_REQUEST = typeof NEW_INBOX_SET_FB_TOKEN_REQUEST;

export const NEW_INBOX_SET_FB_TOKEN_SUCCESS = 'NEW_INBOX_SET_FB_TOKEN_SUCCESS';
export type NEW_INBOX_SET_FB_TOKEN_SUCCESS = typeof NEW_INBOX_SET_FB_TOKEN_SUCCESS;

export const NEW_INBOX_SET_FB_TOKEN_FAILURE = 'NEW_INBOX_SET_FB_TOKEN_FAILURE';
export type NEW_INBOX_SET_FB_TOKEN_FAILURE = typeof NEW_INBOX_SET_FB_TOKEN_FAILURE;

export const CLEAR_SOCIAL_TOKEN_REQUEST = 'CLEAR_SOCIAL_TOKEN_REQUEST';
export type CLEAR_SOCIAL_TOKEN_REQUEST = typeof CLEAR_SOCIAL_TOKEN_REQUEST;

export const CLEAR_SOCIAL_TOKEN_SUCCESS = 'CLEAR_SOCIAL_TOKEN_SUCCESS';
export type CLEAR_SOCIAL_TOKEN_SUCCESS = typeof CLEAR_SOCIAL_TOKEN_SUCCESS;

export const CLEAR_SOCIAL_TOKEN_FAILURE = 'CLEAR_SOCIAL_TOKEN_FAILURE';
export type CLEAR_SOCIAL_TOKEN_FAILURE = typeof CLEAR_SOCIAL_TOKEN_FAILURE;

export const NEW_INBOX_CLEAR_SOCIAL_TOKEN_REQUEST = 'NEW_INBOX_CLEAR_SOCIAL_TOKEN_REQUEST';
export type NEW_INBOX_CLEAR_SOCIAL_TOKEN_REQUEST = typeof NEW_INBOX_CLEAR_SOCIAL_TOKEN_REQUEST;

export const NEW_INBOX_CLEAR_SOCIAL_TOKEN_SUCCESS = 'NEW_INBOX_CLEAR_SOCIAL_TOKEN_SUCCESS';
export type NEW_INBOX_CLEAR_SOCIAL_TOKEN_SUCCESS = typeof NEW_INBOX_CLEAR_SOCIAL_TOKEN_SUCCESS;

export const NEW_INBOX_CLEAR_SOCIAL_TOKEN_FAILURE = 'NEW_INBOX_CLEAR_SOCIAL_TOKEN_FAILURE';
export type NEW_INBOX_CLEAR_SOCIAL_TOKEN_FAILURE = typeof NEW_INBOX_CLEAR_SOCIAL_TOKEN_FAILURE;

export const GET_ASSOCIATED_FBPAGES_REQUEST = 'GET_ASSOCIATED_FBPAGES_REQUEST';
export type GET_ASSOCIATED_FBPAGES_REQUEST = typeof GET_ASSOCIATED_FBPAGES_REQUEST;

export const GET_ASSOCIATED_FBPAGES_SUCCESS = 'GET_ASSOCIATED_FBPAGES_SUCCESS';
export type GET_ASSOCIATED_FBPAGES_SUCCESS = typeof GET_ASSOCIATED_FBPAGES_SUCCESS;

export const GET_ASSOCIATED_FBPAGES_FAILURE = 'GET_ASSOCIATED_FBPAGES_FAILURE';
export type GET_ASSOCIATED_FBPAGES_FAILURE = typeof GET_ASSOCIATED_FBPAGES_FAILURE;

export const SET_ASSOCIATED_FBPAGE_REQUEST = 'SET_ASSOCIATED_FBPAGE_REQUEST';
export type SET_ASSOCIATED_FBPAGE_REQUEST = typeof SET_ASSOCIATED_FBPAGE_REQUEST;

export const SET_ASSOCIATED_FBPAGE_SUCCESS = 'SET_ASSOCIATED_FBPAGE_SUCCESS';
export type SET_ASSOCIATED_FBPAGE_SUCCESS = typeof SET_ASSOCIATED_FBPAGE_SUCCESS;

export const SET_ASSOCIATED_FBPAGE_FAILURE = 'SET_ASSOCIATED_FBPAGE_FAILURE';
export type SET_ASSOCIATED_FBPAGE_FAILURE = typeof SET_ASSOCIATED_FBPAGE_FAILURE;

export const NEW_INBOX_SET_ASSOCIATED_FBPAGE_REQUEST = 'NEW_INBOX_SET_ASSOCIATED_FBPAGE_REQUEST';
export type NEW_INBOX_SET_ASSOCIATED_FBPAGE_REQUEST = typeof NEW_INBOX_SET_ASSOCIATED_FBPAGE_REQUEST;

export const NEW_INBOX_SET_ASSOCIATED_FBPAGE_SUCCESS = 'NEW_INBOX_SET_ASSOCIATED_FBPAGE_SUCCESS';
export type NEW_INBOX_SET_ASSOCIATED_FBPAGE_SUCCESS = typeof NEW_INBOX_SET_ASSOCIATED_FBPAGE_SUCCESS;

export const NEW_INBOX_SET_ASSOCIATED_FBPAGE_FAILURE = 'NEW_INBOX_SET_ASSOCIATED_FBPAGE_FAILURE';
export type NEW_INBOX_SET_ASSOCIATED_FBPAGE_FAILURE = typeof NEW_INBOX_SET_ASSOCIATED_FBPAGE_FAILURE;

export const SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST = 'SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST';
export type SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST = typeof SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST;

export const SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS = 'SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS';
export type SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS = typeof SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS;

export const SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE = 'SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE';
export type SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE = typeof SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE;

export const NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST = 'NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST';
export type NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST = typeof NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST;

export const NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS = 'NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS';
export type NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS = typeof NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS;

export const NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE = 'NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE';
export type NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE = typeof NEW_INBOX_SET_SUBSCRIBE_INSTAGRAM_MENTIONS_FAILURE;

export const SET_BILLING_EMAIL_REQUEST = 'SET_BILLING_EMAIL_REQUEST';
export type SET_BILLING_EMAIL_REQUEST = typeof SET_BILLING_EMAIL_REQUEST;

export const SET_BILLING_EMAIL_SUCCESS = 'SET_BILLING_EMAIL_SUCCESS';
export type SET_BILLING_EMAIL_SUCCESS = typeof SET_BILLING_EMAIL_SUCCESS;

export const SET_BILLING_EMAIL_FAILURE = 'SET_BILLING_EMAIL_FAILURE';
export type SET_BILLING_EMAIL_FAILURE = typeof SET_BILLING_EMAIL_FAILURE;

export const GET_IG_INSIGHTS_REQUEST = 'GET_IG_INSIGHTS_REQUEST';
export type GET_IG_INSIGHTS_REQUEST = typeof GET_IG_INSIGHTS_REQUEST;

export const GET_IG_INSIGHTS_SUCCESS = 'GET_IG_INSIGHTS_SUCCESS';
export type GET_IG_INSIGHTS_SUCCESS = typeof GET_IG_INSIGHTS_SUCCESS;

export const GET_IG_INSIGHTS_FAILURE = 'GET_IG_INSIGHTS_FAILURE';
export type GET_IG_INSIGHTS_FAILURE = typeof GET_IG_INSIGHTS_FAILURE;

export const GET_TWITTER_REQ_TOKEN_REQUEST = 'GET_TWITTER_REQ_TOKEN_REQUEST';
export type GET_TWITTER_REQ_TOKEN_REQUEST = typeof GET_TWITTER_REQ_TOKEN_REQUEST;

export const GET_TWITTER_REQ_TOKEN_SUCCESS = 'GET_TWITTER_REQ_TOKEN_SUCCESS';
export type GET_TWITTER_REQ_TOKEN_SUCCESS = typeof GET_TWITTER_REQ_TOKEN_SUCCESS;

export const GET_TWITTER_REQ_TOKEN_FAILURE = 'GET_TWITTER_REQ_TOKEN_FAILURE';
export type GET_TWITTER_REQ_TOKEN_FAILURE = typeof GET_TWITTER_REQ_TOKEN_FAILURE;

export const SET_TWITTER_ACC_TOKEN_REQUEST = 'SET_TWITTER_ACC_TOKEN_REQUEST';
export type SET_TWITTER_ACC_TOKEN_REQUEST = typeof SET_TWITTER_ACC_TOKEN_REQUEST;

export const SET_TWITTER_ACC_TOKEN_SUCCESS = 'SET_TWITTER_ACC_TOKEN_SUCCESS';
export type SET_TWITTER_ACC_TOKEN_SUCCESS = typeof SET_TWITTER_ACC_TOKEN_SUCCESS;

export const SET_TWITTER_ACC_TOKEN_FAILURE = 'SET_TWITTER_ACC_TOKEN_FAILURE';
export type SET_TWITTER_ACC_TOKEN_FAILURE = typeof SET_TWITTER_ACC_TOKEN_FAILURE;

export const NEW_INBOX_SET_TWITTER_ACC_TOKEN_REQUEST = 'NEW_INBOX_SET_TWITTER_ACC_TOKEN_REQUEST';
export type NEW_INBOX_SET_TWITTER_ACC_TOKEN_REQUEST = typeof NEW_INBOX_SET_TWITTER_ACC_TOKEN_REQUEST;

export const NEW_INBOX_SET_TWITTER_ACC_TOKEN_SUCCESS = 'NEW_INBOX_SET_TWITTER_ACC_TOKEN_SUCCESS';
export type NEW_INBOX_SET_TWITTER_ACC_TOKEN_SUCCESS = typeof NEW_INBOX_SET_TWITTER_ACC_TOKEN_SUCCESS;

export const NEW_INBOX_SET_TWITTER_ACC_TOKEN_FAILURE = 'NEW_INBOX_SET_TWITTER_ACC_TOKEN_FAILURE';
export type NEW_INBOX_SET_TWITTER_ACC_TOKEN_FAILURE = typeof NEW_INBOX_SET_TWITTER_ACC_TOKEN_FAILURE;

export const SET_YOUTUBE_ACC_TOKEN_REQUEST = 'SET_YOUTUBE_ACC_TOKEN_REQUEST';
export type SET_YOUTUBE_ACC_TOKEN_REQUEST = typeof SET_YOUTUBE_ACC_TOKEN_REQUEST;

export const SET_YOUTUBE_ACC_TOKEN_SUCCESS = 'SET_YOUTUBE_ACC_TOKEN_SUCCESS';
export type SET_YOUTUBE_ACC_TOKEN_SUCCESS = typeof SET_YOUTUBE_ACC_TOKEN_SUCCESS;

export const SET_YOUTUBE_ACC_TOKEN_FAILURE = 'SET_YOUTUBE_ACC_TOKEN_FAILURE';
export type SET_YOUTUBE_ACC_TOKEN_FAILURE = typeof SET_YOUTUBE_ACC_TOKEN_FAILURE;

export const NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_REQUEST = 'NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_REQUEST';
export type NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_REQUEST = typeof NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_REQUEST;

export const NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_SUCCESS = 'NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_SUCCESS';
export type NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_SUCCESS = typeof NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_SUCCESS;

export const NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_FAILURE = 'NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_FAILURE';
export type NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_FAILURE = typeof NEW_INBOX_SET_YOUTUBE_ACC_TOKEN_FAILURE;

export const SET_ANALYTICS_DATE_RANGE = 'SET_ANALYTICS_DATE_RANGE';
export type SET_ANALYTICS_DATE_RANGE = typeof SET_ANALYTICS_DATE_RANGE;

export const SET_ANALYTICS_PLATFORMS = 'SET_ANALYTICS_PLATFORMS';
export type SET_ANALYTICS_PLATFORMS = typeof SET_ANALYTICS_PLATFORMS;

export const SET_ANALYTICS_INTERVAL = 'SET_ANALYTICS_INTERVAL';
export type SET_ANALYTICS_INTERVAL = typeof SET_ANALYTICS_INTERVAL;

export const GET_BOARD_ANALYTICS_REQUEST = 'GET_BOARD_ANALYTICS_REQUEST';
export type GET_BOARD_ANALYTICS_REQUEST = typeof GET_BOARD_ANALYTICS_REQUEST;

export const GET_BOARD_ANALYTICS_SUCCESS = 'GET_BOARD_ANALYTICS_SUCCESS';
export type GET_BOARD_ANALYTICS_SUCCESS = typeof GET_BOARD_ANALYTICS_SUCCESS;

export const GET_BOARD_ANALYTICS_FAILURE = 'GET_BOARD_ANALYTICS_FAILURE';
export type GET_BOARD_ANALYTICS_FAILURE = typeof GET_BOARD_ANALYTICS_FAILURE;

export const SET_BOARD_META_REQUEST = 'SET_BOARD_META_REQUEST';
export type SET_BOARD_META_REQUEST = typeof SET_BOARD_META_REQUEST;

export const SET_BOARD_META_SUCCESS = 'SET_BOARD_META_SUCCESS';
export type SET_BOARD_META_SUCCESS = typeof SET_BOARD_META_SUCCESS;

export const SET_BOARD_META_FAILURE = 'SET_BOARD_META_FAILURE';
export type SET_BOARD_META_FAILURE = typeof SET_BOARD_META_FAILURE;

export const CREATE_POST_REQUEST = 'CREATE_POST_REQUEST';
export type CREATE_POST_REQUEST = typeof CREATE_POST_REQUEST;

export const CREATE_POST_SUCCESS = 'CREATE_POST_SUCCESS';
export type CREATE_POST_SUCCESS = typeof CREATE_POST_SUCCESS;

export const CREATE_POST_FAILURE = 'CREATE_POST_FAILURE';
export type CREATE_POST_FAILURE = typeof CREATE_POST_FAILURE;

export const UPDATE_POST_REQUEST = 'UPDATE_POST_REQUEST';
export type UPDATE_POST_REQUEST = typeof UPDATE_POST_REQUEST;

export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS';
export type UPDATE_POST_SUCCESS = typeof UPDATE_POST_SUCCESS;

export const UPDATE_POST_FAILURE = 'UPDATE_POST_FAILURE';
export type UPDATE_POST_FAILURE = typeof UPDATE_POST_FAILURE;

export const BLOCK_BOARD_WORDS_REQUEST = 'BLOCK_BOARD_WORDS_REQUEST';
export type BLOCK_BOARD_WORDS_REQUEST = typeof BLOCK_BOARD_WORDS_REQUEST;

export const BLOCK_BOARD_WORDS_SUCCESS = 'BLOCK_BOARD_WORDS_SUCCESS';
export type BLOCK_BOARD_WORDS_SUCCESS = typeof BLOCK_BOARD_WORDS_SUCCESS;

export const BLOCK_BOARD_WORDS_FAILURE = 'BLOCK_BOARD_WORDS_FAILURE';
export type BLOCK_BOARD_WORDS_FAILURE = typeof BLOCK_BOARD_WORDS_FAILURE;

export const UNBLOCK_BOARD_WORDS_REQUEST = 'UNBLOCK_BOARD_WORDS_REQUEST';
export type UNBLOCK_BOARD_WORDS_REQUEST = typeof UNBLOCK_BOARD_WORDS_REQUEST;

export const UNBLOCK_BOARD_WORDS_SUCCESS = 'UNBLOCK_BOARD_WORDS_SUCCESS';
export type UNBLOCK_BOARD_WORDS_SUCCESS = typeof UNBLOCK_BOARD_WORDS_SUCCESS;

export const UNBLOCK_BOARD_WORDS_FAILURE = 'UNBLOCK_BOARD_WORDS_FAILURE';
export type UNBLOCK_BOARD_WORDS_FAILURE = typeof UNBLOCK_BOARD_WORDS_FAILURE;

export const TOGGLE_BOARD_WORD_BLACKLIST_REQUEST = 'TOGGLE_BOARD_WORD_BLACKLIST_REQUEST';
export type TOGGLE_BOARD_WORD_BLACKLIST_REQUEST = typeof TOGGLE_BOARD_WORD_BLACKLIST_REQUEST;

export const TOGGLE_BOARD_WORD_BLACKLIST_SUCCESS = 'TOGGLE_BOARD_WORD_BLACKLIST_SUCCESS';
export type TOGGLE_BOARD_WORD_BLACKLIST_SUCCESS = typeof TOGGLE_BOARD_WORD_BLACKLIST_SUCCESS;

export const TOGGLE_BOARD_WORD_BLACKLIST_FAILURE = 'TOGGLE_BOARD_WORD_BLACKLIST_FAILURE';
export type TOGGLE_BOARD_WORD_BLACKLIST_FAILURE = typeof TOGGLE_BOARD_WORD_BLACKLIST_FAILURE;

export const INF_SET_FB_TOKEN_REQUEST = 'INF_SET_FB_TOKEN_REQUEST';
export type INF_SET_FB_TOKEN_REQUEST = typeof INF_SET_FB_TOKEN_REQUEST;

export const INF_SET_FB_TOKEN_SUCCESS = 'INF_SET_FB_TOKEN_SUCCESS';
export type INF_SET_FB_TOKEN_SUCCESS = typeof INF_SET_FB_TOKEN_SUCCESS;

export const INF_SET_FB_TOKEN_FAILURE = 'INF_SET_FB_TOKEN_FAILURE';
export type INF_SET_FB_TOKEN_FAILURE = typeof INF_SET_FB_TOKEN_FAILURE;

export const INF_GET_ASSOCIATED_FBPAGES_REQUEST = 'INF_GET_ASSOCIATED_FBPAGES_REQUEST';
export type INF_GET_ASSOCIATED_FBPAGES_REQUEST = typeof INF_GET_ASSOCIATED_FBPAGES_REQUEST;

export const INF_GET_ASSOCIATED_FBPAGES_SUCCESS = 'INF_GET_ASSOCIATED_FBPAGES_SUCCESS';
export type INF_GET_ASSOCIATED_FBPAGES_SUCCESS = typeof INF_GET_ASSOCIATED_FBPAGES_SUCCESS;

export const INF_GET_ASSOCIATED_FBPAGES_FAILURE = 'INF_GET_ASSOCIATED_FBPAGES_FAILURE';
export type INF_GET_ASSOCIATED_FBPAGES_FAILURE = typeof INF_GET_ASSOCIATED_FBPAGES_FAILURE;

export const INF_SET_ASSOCIATED_FBPAGE_REQUEST = 'INF_SET_ASSOCIATED_FBPAGE_REQUEST';
export type INF_SET_ASSOCIATED_FBPAGE_REQUEST = typeof INF_SET_ASSOCIATED_FBPAGE_REQUEST;

export const INF_SET_ASSOCIATED_FBPAGE_SUCCESS = 'INF_SET_ASSOCIATED_FBPAGE_SUCCESS';
export type INF_SET_ASSOCIATED_FBPAGE_SUCCESS = typeof INF_SET_ASSOCIATED_FBPAGE_SUCCESS;

export const INF_SET_ASSOCIATED_FBPAGE_FAILURE = 'INF_SET_ASSOCIATED_FBPAGE_FAILURE';
export type INF_SET_ASSOCIATED_FBPAGE_FAILURE = typeof INF_SET_ASSOCIATED_FBPAGE_FAILURE;

export const INF_CLEAR_SOCIAL_TOKEN_REQUEST = 'INF_CLEAR_SOCIAL_TOKEN_REQUEST';
export type INF_CLEAR_SOCIAL_TOKEN_REQUEST = typeof INF_CLEAR_SOCIAL_TOKEN_REQUEST;

export const INF_CLEAR_SOCIAL_TOKEN_SUCCESS = 'INF_CLEAR_SOCIAL_TOKEN_SUCCESS';
export type INF_CLEAR_SOCIAL_TOKEN_SUCCESS = typeof INF_CLEAR_SOCIAL_TOKEN_SUCCESS;

export const INF_CLEAR_SOCIAL_TOKEN_FAILURE = 'INF_CLEAR_SOCIAL_TOKEN_FAILURE';
export type INF_CLEAR_SOCIAL_TOKEN_FAILURE = typeof INF_CLEAR_SOCIAL_TOKEN_FAILURE;

export const INF_GET_TWITTER_REQ_TOKEN_REQUEST = 'INF_GET_TWITTER_REQ_TOKEN_REQUEST';
export type INF_GET_TWITTER_REQ_TOKEN_REQUEST = typeof INF_GET_TWITTER_REQ_TOKEN_REQUEST;

export const INF_GET_TWITTER_REQ_TOKEN_SUCCESS = 'INF_GET_TWITTER_REQ_TOKEN_SUCCESS';
export type INF_GET_TWITTER_REQ_TOKEN_SUCCESS = typeof INF_GET_TWITTER_REQ_TOKEN_SUCCESS;

export const INF_GET_TWITTER_REQ_TOKEN_FAILURE = 'INF_GET_TWITTER_REQ_TOKEN_FAILURE';
export type INF_GET_TWITTER_REQ_TOKEN_FAILURE = typeof INF_GET_TWITTER_REQ_TOKEN_FAILURE;

export const INF_SET_TWITTER_ACC_TOKEN_REQUEST = 'INF_SET_TWITTER_ACC_TOKEN_REQUEST';
export type INF_SET_TWITTER_ACC_TOKEN_REQUEST = typeof INF_SET_TWITTER_ACC_TOKEN_REQUEST;

export const INF_SET_TWITTER_ACC_TOKEN_SUCCESS = 'INF_SET_TWITTER_ACC_TOKEN_SUCCESS';
export type INF_SET_TWITTER_ACC_TOKEN_SUCCESS = typeof INF_SET_TWITTER_ACC_TOKEN_SUCCESS;

export const INF_SET_TWITTER_ACC_TOKEN_FAILURE = 'INF_SET_TWITTER_ACC_TOKEN_FAILURE';
export type INF_SET_TWITTER_ACC_TOKEN_FAILURE = typeof INF_SET_TWITTER_ACC_TOKEN_FAILURE;

export const INF_SET_YOUTUBE_ACC_TOKEN_REQUEST = 'INF_SET_YOUTUBE_ACC_TOKEN_REQUEST';
export type INF_SET_YOUTUBE_ACC_TOKEN_REQUEST = typeof INF_SET_YOUTUBE_ACC_TOKEN_REQUEST;

export const INF_SET_YOUTUBE_ACC_TOKEN_SUCCESS = 'INF_SET_YOUTUBE_ACC_TOKEN_SUCCESS';
export type INF_SET_YOUTUBE_ACC_TOKEN_SUCCESS = typeof INF_SET_YOUTUBE_ACC_TOKEN_SUCCESS;

export const INF_SET_YOUTUBE_ACC_TOKEN_FAILURE = 'INF_SET_YOUTUBE_ACC_TOKEN_FAILURE';
export type INF_SET_YOUTUBE_ACC_TOKEN_FAILURE = typeof INF_SET_YOUTUBE_ACC_TOKEN_FAILURE;

export const FINALIZE_INFLUENCER_FORM_REQUEST = 'FINALIZE_INFLUENCER_FORM_REQUEST';
export type FINALIZE_INFLUENCER_FORM_REQUEST = typeof FINALIZE_INFLUENCER_FORM_REQUEST;

export const FINALIZE_INFLUENCER_FORM_SUCCESS = 'FINALIZE_INFLUENCER_FORM_SUCCESS';
export type FINALIZE_INFLUENCER_FORM_SUCCESS = typeof FINALIZE_INFLUENCER_FORM_SUCCESS;

export const FINALIZE_INFLUENCER_FORM_FAILURE = 'FINALIZE_INFLUENCER_FORM_FAILURE';
export type FINALIZE_INFLUENCER_FORM_FAILURE = typeof FINALIZE_INFLUENCER_FORM_FAILURE;

export const HANDLE_NEW_STORIES = 'HANDLE_NEW_STORIES';
export type HANDLE_NEW_STORIES = typeof HANDLE_NEW_STORIES;

export const CLEAR_STORY_PUSH_INFO = 'CLEAR_STORY_PUSH_INFO';
export type CLEAR_STORY_PUSH_INFO = typeof CLEAR_STORY_PUSH_INFO;

export const ADMIN_SYSTEM_SUMMARY_REQUEST = 'ADMIN_SYSTEM_SUMMARY_REQUEST';
export type ADMIN_SYSTEM_SUMMARY_REQUEST = typeof ADMIN_SYSTEM_SUMMARY_REQUEST;

export const ADMIN_SYSTEM_SUMMARY_SUCCESS = 'ADMIN_SYSTEM_SUMMARY_SUCCESS';
export type ADMIN_SYSTEM_SUMMARY_SUCCESS = typeof ADMIN_SYSTEM_SUMMARY_SUCCESS;

export const ADMIN_SYSTEM_SUMMARY_FAILURE = 'ADMIN_SYSTEM_SUMMARY_FAILURE';
export type ADMIN_SYSTEM_SUMMARY_FAILURE = typeof ADMIN_SYSTEM_SUMMARY_FAILURE;

export const ADMIN_ORG_PAGE_REQUEST = 'ADMIN_ORG_PAGE_REQUEST';
export type ADMIN_ORG_PAGE_REQUEST = typeof ADMIN_ORG_PAGE_REQUEST;

export const ADMIN_ORG_PAGE_SUCCESS = 'ADMIN_ORG_PAGE_SUCCESS';
export type ADMIN_ORG_PAGE_SUCCESS = typeof ADMIN_ORG_PAGE_SUCCESS;

export const ADMIN_ORG_PAGE_FAILURE = 'ADMIN_ORG_PAGE_FAILURE';
export type ADMIN_ORG_PAGE_FAILURE = typeof ADMIN_ORG_PAGE_FAILURE;

export const ADMIN_ORG_API_PLANS_REQUEST = 'ADMIN_ORG_API_PLANS_REQUEST';
export type ADMIN_ORG_API_PLANS_REQUEST = typeof ADMIN_ORG_API_PLANS_REQUEST;

export const ADMIN_ORG_API_PLANS_SUCCESS = 'ADMIN_ORG_API_PLANS_SUCCESS';
export type ADMIN_ORG_API_PLANS_SUCCESS = typeof ADMIN_ORG_API_PLANS_SUCCESS;

export const ADMIN_ORG_API_PLANS_FAILURE = 'ADMIN_ORG_API_PLANS_FAILURE';
export type ADMIN_ORG_API_PLANS_FAILURE = typeof ADMIN_ORG_API_PLANS_FAILURE;

export const ADMIN_ORG_MODIFY_REQUEST = 'ADMIN_ORG_MODIFY_REQUEST';
export type ADMIN_ORG_MODIFY_REQUEST = typeof ADMIN_ORG_MODIFY_REQUEST;

export const ADMIN_ORG_MODIFY_SUCCESS = 'ADMIN_ORG_MODIFY_SUCCESS';
export type ADMIN_ORG_MODIFY_SUCCESS = typeof ADMIN_ORG_MODIFY_SUCCESS;

export const ADMIN_ORG_MODIFY_FAILURE = 'ADMIN_ORG_MODIFY_FAILURE';
export type ADMIN_ORG_MODIFY_FAILURE = typeof ADMIN_ORG_MODIFY_FAILURE;

export const ADMIN_ORG_DELETE_REQUEST = 'ADMIN_ORG_DELETE_REQUEST';
export type ADMIN_ORG_DELETE_REQUEST = typeof ADMIN_ORG_DELETE_REQUEST;

export const ADMIN_ORG_DELETE_SUCCESS = 'ADMIN_ORG_DELETE_SUCCESS';
export type ADMIN_ORG_DELETE_SUCCESS = typeof ADMIN_ORG_DELETE_SUCCESS;

export const ADMIN_ORG_DELETE_FAILURE = 'ADMIN_ORG_DELETE_FAILURE';
export type ADMIN_ORG_DELETE_FAILURE = typeof ADMIN_ORG_DELETE_FAILURE;

export const ADMIN_BOARD_FETCH_POSTS_REQUEST = 'ADMIN_BOARD_FETCH_POSTS_REQUEST';
export type ADMIN_BOARD_FETCH_POSTS_REQUEST = typeof ADMIN_BOARD_FETCH_POSTS_REQUEST;

export const ADMIN_BOARD_FETCH_POSTS_SUCCESS = 'ADMIN_BOARD_FETCH_POSTS_SUCCESS';
export type ADMIN_BOARD_FETCH_POSTS_SUCCESS = typeof ADMIN_BOARD_FETCH_POSTS_SUCCESS;

export const ADMIN_BOARD_FETCH_POSTS_FAILURE = 'ADMIN_BOARD_FETCH_POSTS_FAILURE';
export type ADMIN_BOARD_FETCH_POSTS_FAILURE = typeof ADMIN_BOARD_FETCH_POSTS_FAILURE;

export const ADMIN_ORGS_LIST_REQUEST = 'ADMIN_ORGS_LIST_REQUEST';
export type ADMIN_ORGS_LIST_REQUEST = typeof ADMIN_ORGS_LIST_REQUEST;

export const ADMIN_ORGS_LIST_SUCCESS = 'ADMIN_ORGS_LIST_SUCCESS';
export type ADMIN_ORGS_LIST_SUCCESS = typeof ADMIN_ORGS_LIST_SUCCESS;

export const ADMIN_ORGS_LIST_FAILURE = 'ADMIN_ORGS_LIST_FAILURE';
export type ADMIN_ORGS_LIST_FAILURE = typeof ADMIN_ORGS_LIST_FAILURE;

export const ADMIN_BOARD_META_MODIFY_REQUEST = 'ADMIN_BOARD_META_MODIFY_REQUEST';
export type ADMIN_BOARD_META_MODIFY_REQUEST = typeof ADMIN_BOARD_META_MODIFY_REQUEST;

export const ADMIN_BOARD_META_MODIFY_SUCCESS = 'ADMIN_BOARD_META_MODIFY_SUCCESS';
export type ADMIN_BOARD_META_MODIFY_SUCCESS = typeof ADMIN_BOARD_META_MODIFY_SUCCESS;

export const ADMIN_BOARD_META_MODIFY_FAILURE = 'ADMIN_BOARD_META_MODIFY_FAILURE';
export type ADMIN_BOARD_META_MODIFY_FAILURE = typeof ADMIN_BOARD_META_MODIFY_FAILURE;

export const ADMIN_COMPETITION_META_MODIFY_REQUEST = 'ADMIN_COMPETITION_META_MODIFY_REQUEST';
export type ADMIN_COMPETITION_META_MODIFY_REQUEST = typeof ADMIN_COMPETITION_META_MODIFY_REQUEST;

export const ADMIN_COMPETITION_META_MODIFY_SUCCESS = 'ADMIN_COMPETITION_META_MODIFY_SUCCESS';
export type ADMIN_COMPETITION_META_MODIFY_SUCCESS = typeof ADMIN_COMPETITION_META_MODIFY_SUCCESS;

export const ADMIN_COMPETITION_META_MODIFY_FAILURE = 'ADMIN_COMPETITION_META_MODIFY_FAILURE';
export type ADMIN_COMPETITION_META_MODIFY_FAILURE = typeof ADMIN_COMPETITION_META_MODIFY_FAILURE;

export const ADMIN_ORG_GET_BOARDS_SUMMARY_REQUEST = 'ADMIN_ORG_GET_BOARDS_SUMMARY_REQUEST';
export type ADMIN_ORG_GET_BOARDS_SUMMARY_REQUEST = typeof ADMIN_ORG_GET_BOARDS_SUMMARY_REQUEST;

export const ADMIN_ORG_GET_BOARDS_SUMMARY_SUCCESS = 'ADMIN_ORG_GET_BOARDS_SUMMARY_SUCCESS';
export type ADMIN_ORG_GET_BOARDS_SUMMARY_SUCCESS = typeof ADMIN_ORG_GET_BOARDS_SUMMARY_SUCCESS;

export const ADMIN_ORG_GET_BOARDS_SUMMARY_FAILURE = 'ADMIN_ORG_GET_BOARDS_SUMMARY_FAILURE';
export type ADMIN_ORG_GET_BOARDS_SUMMARY_FAILURE = typeof ADMIN_ORG_GET_BOARDS_SUMMARY_FAILURE;

export const ADMIN_MODIFY_KEYWORDS_REQUEST = 'ADMIN_MODIFY_KEYWORDS_REQUEST';
export type ADMIN_MODIFY_KEYWORDS_REQUEST = typeof ADMIN_MODIFY_KEYWORDS_REQUEST;

export const ADMIN_MODIFY_KEYWORDS_SUCCESS = 'ADMIN_MODIFY_KEYWORDS_SUCCESS';
export type ADMIN_MODIFY_KEYWORDS_SUCCESS = typeof ADMIN_MODIFY_KEYWORDS_SUCCESS;

export const ADMIN_MODIFY_KEYWORDS_FAILURE = 'ADMIN_MODIFY_KEYWORDS_FAILURE';
export type ADMIN_MODIFY_KEYWORDS_FAILURE = typeof ADMIN_MODIFY_KEYWORDS_FAILURE;

export const ADMIN_ADD_KEYWORD_REQUEST = 'ADMIN_ADD_KEYWORD_REQUEST';
export type ADMIN_ADD_KEYWORD_REQUEST = typeof ADMIN_ADD_KEYWORD_REQUEST;

export const ADMIN_ADD_KEYWORD_SUCCESS = 'ADMIN_ADD_KEYWORD_SUCCESS';
export type ADMIN_ADD_KEYWORD_SUCCESS = typeof ADMIN_ADD_KEYWORD_SUCCESS;

export const ADMIN_ADD_KEYWORD_FAILURE = 'ADMIN_ADD_KEYWORD_FAILURE';
export type ADMIN_ADD_KEYWORD_FAILURE = typeof ADMIN_ADD_KEYWORD_FAILURE;

export const CREATE_COMPETITION_REQUEST = 'CREATE_COMPETITION_REQUEST';
export type CREATE_COMPETITION_REQUEST = typeof CREATE_COMPETITION_REQUEST;

export const CREATE_COMPETITION_SUCCESS = 'CREATE_COMPETITION_SUCCESS';
export type CREATE_COMPETITION_SUCCESS = typeof CREATE_COMPETITION_SUCCESS;

export const CREATE_COMPETITION_FAILURE = 'CREATE_COMPETITION_FAILURE';
export type CREATE_COMPETITION_FAILURE = typeof CREATE_COMPETITION_FAILURE;

export const SET_COMPETITIONS = 'SET_COMPETITIONS';
export type SET_COMPETITIONS = typeof SET_COMPETITIONS;

export const CLEAR_COMPETITION = 'CLEAR_COMPETITION';
export type CLEAR_COMPETITION = typeof CLEAR_COMPETITION;

export const GET_COMPETITION_REQUEST = 'GET_COMPETITION_REQUEST';
export type GET_COMPETITION_REQUEST = typeof GET_COMPETITION_REQUEST;

export const GET_COMPETITION_SUCCESS = 'GET_COMPETITION_SUCCESS';
export type GET_COMPETITION_SUCCESS = typeof GET_COMPETITION_SUCCESS;

export const GET_COMPETITION_FAILURE = 'GET_COMPETITION_FAILURE';
export type GET_COMPETITION_FAILURE = typeof GET_COMPETITION_FAILURE;

export const UPDATE_COMPETITION_REQUEST = 'UPDATE_COMPETITION_REQUEST';
export type UPDATE_COMPETITION_REQUEST = typeof UPDATE_COMPETITION_REQUEST;

export const UPDATE_COMPETITION_SUCCESS = 'UPDATE_COMPETITION_SUCCESS';
export type UPDATE_COMPETITION_SUCCESS = typeof UPDATE_COMPETITION_SUCCESS;

export const UPDATE_COMPETITION_FAILURE = 'UPDATE_COMPETITION_FAILURE';
export type UPDATE_COMPETITION_FAILURE = typeof UPDATE_COMPETITION_FAILURE;

export const DELETE_COMPETITION_REQUEST = 'DELETE_COMPETITION_REQUEST';
export type DELETE_COMPETITION_REQUEST = typeof DELETE_COMPETITION_REQUEST;

export const DELETE_COMPETITION_SUCCESS = 'DELETE_COMPETITION_SUCCESS';
export type DELETE_COMPETITION_SUCCESS = typeof DELETE_COMPETITION_SUCCESS;

export const DELETE_COMPETITION_FAILURE = 'DELETE_COMPETITION_FAILURE';
export type DELETE_COMPETITION_FAILURE = typeof DELETE_COMPETITION_FAILURE;

export const GET_COMPETITION_MEMBER_LIST_REQUEST = 'GET_COMPETITION_MEMBER_LIST_REQUEST';
export type GET_COMPETITION_MEMBER_LIST_REQUEST = typeof GET_COMPETITION_MEMBER_LIST_REQUEST;

export const GET_COMPETITION_MEMBER_LIST_SUCCESS = 'GET_COMPETITION_MEMBER_LIST_SUCCESS';
export type GET_COMPETITION_MEMBER_LIST_SUCCESS = typeof GET_COMPETITION_MEMBER_LIST_SUCCESS;

export const GET_COMPETITION_MEMBER_LIST_FAILURE = 'GET_COMPETITION_MEMBER_LIST_FAILURE';
export type GET_COMPETITION_MEMBER_LIST_FAILURE = typeof GET_COMPETITION_MEMBER_LIST_FAILURE;

export const UPDATE_COMPETITION_MEMBER_ROLE_REQUEST = 'UPDATE_COMPETITION_MEMBER_ROLE_REQUEST';
export type UPDATE_COMPETITION_MEMBER_ROLE_REQUEST = typeof UPDATE_COMPETITION_MEMBER_ROLE_REQUEST;

export const UPDATE_COMPETITION_MEMBER_ROLE_SUCCESS = 'UPDATE_COMPETITION_MEMBER_ROLE_SUCCESS';
export type UPDATE_COMPETITION_MEMBER_ROLE_SUCCESS = typeof UPDATE_COMPETITION_MEMBER_ROLE_SUCCESS;

export const UPDATE_COMPETITION_MEMBER_ROLE_FAILURE = 'UPDATE_COMPETITION_MEMBER_ROLE_FAILURE';
export type UPDATE_COMPETITION_MEMBER_ROLE_FAILURE = typeof UPDATE_COMPETITION_MEMBER_ROLE_FAILURE;

export const INVITE_COMPETITION_MEMBERS_REQUEST = 'INVITE_COMPETITION_MEMBERS_REQUEST';
export type INVITE_COMPETITION_MEMBERS_REQUEST = typeof INVITE_COMPETITION_MEMBERS_REQUEST;

export const INVITE_COMPETITION_MEMBERS_SUCCESS = 'INVITE_COMPETITION_MEMBERS_SUCCESS';
export type INVITE_COMPETITION_MEMBERS_SUCCESS = typeof INVITE_COMPETITION_MEMBERS_SUCCESS;

export const INVITE_COMPETITION_MEMBERS_FAILURE = 'INVITE_COMPETITION_MEMBERS_FAILURE';
export type INVITE_COMPETITION_MEMBERS_FAILURE = typeof INVITE_COMPETITION_MEMBERS_FAILURE;

export const REMOVE_COMPETITION_MEMBER_REQUEST = 'REMOVE_COMPETITION_MEMBER_REQUEST';
export type REMOVE_COMPETITION_MEMBER_REQUEST = typeof REMOVE_COMPETITION_MEMBER_REQUEST;

export const REMOVE_COMPETITION_MEMBER_SUCCESS = 'REMOVE_COMPETITION_MEMBER_SUCCESS';
export type REMOVE_COMPETITION_MEMBER_SUCCESS = typeof REMOVE_COMPETITION_MEMBER_SUCCESS;

export const REMOVE_COMPETITION_MEMBER_FAILURE = 'REMOVE_COMPETITION_MEMBER_FAILURE';
export type REMOVE_COMPETITION_MEMBER_FAILURE = typeof REMOVE_COMPETITION_MEMBER_FAILURE;

export const UPDATE_COMPETITION_EMBED_URL_REQUEST = 'UPDATE_COMPETITION_EMBED_URL_REQUEST';
export type UPDATE_COMPETITION_EMBED_URL_REQUEST = typeof UPDATE_COMPETITION_EMBED_URL_REQUEST;

export const UPDATE_COMPETITION_EMBED_URL_SUCCESS = 'UPDATE_COMPETITION_EMBED_URL_SUCCESS';
export type UPDATE_COMPETITION_EMBED_URL_SUCCESS = typeof UPDATE_COMPETITION_EMBED_URL_SUCCESS;

export const UPDATE_COMPETITION_EMBED_URL_FAILURE = 'UPDATE_COMPETITION_EMBED_URL_FAILURE';
export type UPDATE_COMPETITION_EMBED_URL_FAILURE = typeof UPDATE_COMPETITION_EMBED_URL_FAILURE;

export const GET_COMPETITION_META_REQUEST = 'GET_COMPETITION_META_REQUEST';
export type GET_COMPETITION_META_REQUEST = typeof GET_COMPETITION_META_REQUEST;

export const GET_COMPETITION_META_SUCCESS = 'GET_COMPETITION_META_SUCCESS';
export type GET_COMPETITION_META_SUCCESS = typeof GET_COMPETITION_META_SUCCESS;

export const GET_COMPETITION_META_FAILURE = 'GET_COMPETITION_META_FAILURE';
export type GET_COMPETITION_META_FAILURE = typeof GET_COMPETITION_META_FAILURE;

export const UPDATE_COMPETITION_SHARE_MESSAGING_REQUEST = 'UPDATE_COMPETITION_SHARE_MESSAGING_REQUEST';
export type UPDATE_COMPETITION_SHARE_MESSAGING_REQUEST = typeof UPDATE_COMPETITION_SHARE_MESSAGING_REQUEST;

export const UPDATE_COMPETITION_SHARE_MESSAGING_SUCCESS = 'UPDATE_COMPETITION_SHARE_MESSAGING_SUCCESS';
export type UPDATE_COMPETITION_SHARE_MESSAGING_SUCCESS = typeof UPDATE_COMPETITION_SHARE_MESSAGING_SUCCESS;

export const UPDATE_COMPETITION_SHARE_MESSAGING_FAILURE = 'UPDATE_COMPETITION_SHARE_MESSAGING_FAILURE';
export type UPDATE_COMPETITION_SHARE_MESSAGING_FAILURE = typeof UPDATE_COMPETITION_SHARE_MESSAGING_FAILURE;

export const UPDATE_CUSTOM_CSS_REQUEST = 'UPDATE_CUSTOM_CSS_REQUEST';
export type UPDATE_CUSTOM_CSS_REQUEST = typeof UPDATE_CUSTOM_CSS_REQUEST;

export const UPDATE_CUSTOM_CSS_SUCCESS = 'UPDATE_CUSTOM_CSS_SUCCESS';
export type UPDATE_CUSTOM_CSS_SUCCESS = typeof UPDATE_CUSTOM_CSS_SUCCESS;

export const UPDATE_CUSTOM_CSS_FAILURE = 'UPDATE_CUSTOM_CSS_FAILURE';
export type UPDATE_CUSTOM_CSS_FAILURE = typeof UPDATE_CUSTOM_CSS_FAILURE;

export const TOGGLE_COMPETITION_WORD_BLACKLIST_REQUEST = 'TOGGLE_COMPETITION_WORD_BLACKLIST_REQUEST';
export type TOGGLE_COMPETITION_WORD_BLACKLIST_REQUEST = typeof TOGGLE_COMPETITION_WORD_BLACKLIST_REQUEST;

export const TOGGLE_COMPETITION_WORD_BLACKLIST_SUCCESS = 'TOGGLE_COMPETITION_WORD_BLACKLIST_SUCCESS';
export type TOGGLE_COMPETITION_WORD_BLACKLIST_SUCCESS = typeof TOGGLE_COMPETITION_WORD_BLACKLIST_SUCCESS;

export const TOGGLE_COMPETITION_WORD_BLACKLIST_FAILURE = 'TOGGLE_COMPETITION_WORD_BLACKLIST_FAILURE';
export type TOGGLE_COMPETITION_WORD_BLACKLIST_FAILURE = typeof TOGGLE_COMPETITION_WORD_BLACKLIST_FAILURE;

export const BLOCK_COMPETITION_WORDS_REQUEST = 'BLOCK_COMPETITION_WORDS_REQUEST';
export type BLOCK_COMPETITION_WORDS_REQUEST = typeof BLOCK_COMPETITION_WORDS_REQUEST;

export const BLOCK_COMPETITION_WORDS_SUCCESS = 'BLOCK_COMPETITION_WORDS_SUCCESS';
export type BLOCK_COMPETITION_WORDS_SUCCESS = typeof BLOCK_COMPETITION_WORDS_SUCCESS;

export const BLOCK_COMPETITION_WORDS_FAILURE = 'BLOCK_COMPETITION_WORDS_FAILURE';
export type BLOCK_COMPETITION_WORDS_FAILURE = typeof BLOCK_COMPETITION_WORDS_FAILURE;

export const UNBLOCK_COMPETITION_WORDS_REQUEST = 'UNBLOCK_COMPETITION_WORDS_REQUEST';
export type UNBLOCK_COMPETITION_WORDS_REQUEST = typeof UNBLOCK_COMPETITION_WORDS_REQUEST;

export const UNBLOCK_COMPETITION_WORDS_SUCCESS = 'UNBLOCK_COMPETITION_WORDS_SUCCESS';
export type UNBLOCK_COMPETITION_WORDS_SUCCESS = typeof UNBLOCK_COMPETITION_WORDS_SUCCESS;

export const UNBLOCK_COMPETITION_WORDS_FAILURE = 'UNBLOCK_COMPETITION_WORDS_FAILURE';
export type UNBLOCK_COMPETITION_WORDS_FAILURE = typeof UNBLOCK_COMPETITION_WORDS_FAILURE;

export const SET_COMPETITION_META_REQUEST = 'SET_COMPETITION_META_REQUEST';
export type SET_COMPETITION_META_REQUEST = typeof SET_COMPETITION_META_REQUEST;

export const SET_COMPETITION_META_SUCCESS = 'SET_COMPETITION_META_SUCCESS';
export type SET_COMPETITION_META_SUCCESS = typeof SET_COMPETITION_META_SUCCESS;

export const SET_COMPETITION_META_FAILURE = 'SET_COMPETITION_META_FAILURE';
export type SET_COMPETITION_META_FAILURE = typeof SET_COMPETITION_META_FAILURE;

export const COMPETITION_BLOCK_USERNAME = 'COMPETITION_BLOCK_USERNAME';
export type COMPETITION_BLOCK_USERNAME = typeof COMPETITION_BLOCK_USERNAME;

export const COMPETITION_UNBLOCK_USERNAME = 'COMPETITION_UNBLOCK_USERNAME';
export type COMPETITION_UNBLOCK_USERNAME = typeof COMPETITION_UNBLOCK_USERNAME;

export const SAVE_COMPETITION_STAGES_REQUEST = 'SAVE_COMPETITION_STAGES_REQUEST';
export type SAVE_COMPETITION_STAGES_REQUEST = typeof SAVE_COMPETITION_STAGES_REQUEST;

export const SAVE_COMPETITION_STAGES_SUCCESS = 'SAVE_COMPETITION_STAGES_SUCCESS';
export type SAVE_COMPETITION_STAGES_SUCCESS = typeof SAVE_COMPETITION_STAGES_SUCCESS;

export const SAVE_COMPETITION_STAGES_FAILURE = 'SAVE_COMPETITION_STAGES_FAILURE';
export type SAVE_COMPETITION_STAGES_FAILURE = typeof SAVE_COMPETITION_STAGES_FAILURE;

export const SAVE_COMPETITION_MESSAGING_REQUEST = 'SAVE_COMPETITION_MESSAGING_REQUEST';
export type SAVE_COMPETITION_MESSAGING_REQUEST = typeof SAVE_COMPETITION_MESSAGING_REQUEST;

export const SAVE_COMPETITION_MESSAGING_SUCCESS = 'SAVE_COMPETITION_MESSAGING_SUCCESS';
export type SAVE_COMPETITION_MESSAGING_SUCCESS = typeof SAVE_COMPETITION_MESSAGING_SUCCESS;

export const SAVE_COMPETITION_MESSAGING_FAILURE = 'SAVE_COMPETITION_MESSAGING_FAILURE';
export type SAVE_COMPETITION_MESSAGING_FAILURE = typeof SAVE_COMPETITION_MESSAGING_FAILURE;

export const SAVE_COMPETITION_BACKGROUND_MEDIA_REQUEST = 'SAVE_COMPETITION_BACKGROUND_MEDIA_REQUEST';
export type SAVE_COMPETITION_BACKGROUND_MEDIA_REQUEST = typeof SAVE_COMPETITION_BACKGROUND_MEDIA_REQUEST;

export const SAVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS = 'SAVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS';
export type SAVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS = typeof SAVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS;

export const SAVE_COMPETITION_BACKGROUND_MEDIA_FAILURE = 'SAVE_COMPETITION_BACKGROUND_MEDIA_FAILURE';
export type SAVE_COMPETITION_BACKGROUND_MEDIA_FAILURE = typeof SAVE_COMPETITION_BACKGROUND_MEDIA_FAILURE;

export const SAVE_COMPETITION_PRIZEIMAGE_MEDIA_REQUEST = 'SAVE_COMPETITION_PRIZEIMAGE_MEDIA_REQUEST';
export type SAVE_COMPETITION_PRIZEIMAGE_MEDIA_REQUEST = typeof SAVE_COMPETITION_PRIZEIMAGE_MEDIA_REQUEST;

export const SAVE_COMPETITION_PRIZEIMAGE_MEDIA_SUCCESS = 'SAVE_COMPETITION_PRIZEIMAGE_MEDIA_SUCCESS';
export type SAVE_COMPETITION_PRIZEIMAGE_MEDIA_SUCCESS = typeof SAVE_COMPETITION_PRIZEIMAGE_MEDIA_SUCCESS;

export const SAVE_COMPETITION_PRIZEIMAGE_MEDIA_FAILURE = 'SAVE_COMPETITION_PRIZEIMAGE_MEDIA_FAILURE';
export type SAVE_COMPETITION_PRIZEIMAGE_MEDIA_FAILURE = typeof SAVE_COMPETITION_PRIZEIMAGE_MEDIA_FAILURE;

export const SAVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST = 'SAVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST';
export type SAVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST = typeof SAVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST;

export const SAVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS = 'SAVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS';
export type SAVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS = typeof SAVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS;

export const SAVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE = 'SAVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE';
export type SAVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE = typeof SAVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE;

export const SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST = 'SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST';
export type SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST = typeof SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST;

export const SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS = 'SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS';
export type SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS = typeof SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS;

export const SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE = 'SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE';
export type SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE = typeof SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE;

export const SAVE_COMPETITION_LOGO_MEDIA_REQUEST = 'SAVE_COMPETITION_LOGO_MEDIA_REQUEST';
export type SAVE_COMPETITION_LOGO_MEDIA_REQUEST = typeof SAVE_COMPETITION_LOGO_MEDIA_REQUEST;

export const SAVE_COMPETITION_LOGO_MEDIA_SUCCESS = 'SAVE_COMPETITION_LOGO_MEDIA_SUCCESS';
export type SAVE_COMPETITION_LOGO_MEDIA_SUCCESS = typeof SAVE_COMPETITION_LOGO_MEDIA_SUCCESS;

export const SAVE_COMPETITION_LOGO_MEDIA_FAILURE = 'SAVE_COMPETITION_LOGO_MEDIA_FAILURE';
export type SAVE_COMPETITION_LOGO_MEDIA_FAILURE = typeof SAVE_COMPETITION_LOGO_MEDIA_FAILURE;

export const SAVE_COMPETITION_INTROCOVER_MEDIA_REQUEST = 'SAVE_COMPETITION_INTROCOVER_MEDIA_REQUEST';
export type SAVE_COMPETITION_INTROCOVER_MEDIA_REQUEST = typeof SAVE_COMPETITION_INTROCOVER_MEDIA_REQUEST;

export const SAVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS = 'SAVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS';
export type SAVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS = typeof SAVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS;

export const SAVE_COMPETITION_INTROCOVER_MEDIA_FAILURE = 'SAVE_COMPETITION_INTROCOVER_MEDIA_FAILURE';
export type SAVE_COMPETITION_INTROCOVER_MEDIA_FAILURE = typeof SAVE_COMPETITION_INTROCOVER_MEDIA_FAILURE;

export const REMOVE_COMPETITION_BACKGROUND_MEDIA_REQUEST = 'REMOVE_COMPETITION_BACKGROUND_MEDIA_REQUEST';
export type REMOVE_COMPETITION_BACKGROUND_MEDIA_REQUEST = typeof REMOVE_COMPETITION_BACKGROUND_MEDIA_REQUEST;

export const REMOVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS = 'REMOVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_BACKGROUND_MEDIA_FAILURE = 'REMOVE_COMPETITION_BACKGROUND_MEDIA_FAILURE';
export type REMOVE_COMPETITION_BACKGROUND_MEDIA_FAILURE = typeof REMOVE_COMPETITION_BACKGROUND_MEDIA_FAILURE;

export const REMOVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST = 'REMOVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST';
export type REMOVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST = typeof REMOVE_COMPETITION_INTROVIDEO_MEDIA_REQUEST;

export const REMOVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS = 'REMOVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE = 'REMOVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE';
export type REMOVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE = typeof REMOVE_COMPETITION_INTROVIDEO_MEDIA_FAILURE;

export const REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST = 'REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST';
export type REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST = typeof REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_REQUEST;

export const REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS = 'REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE = 'REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE';
export type REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE = typeof REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_FAILURE;

export const REMOVE_COMPETITION_ADIMAGE1_MEDIA_REQUEST = 'REMOVE_COMPETITION_ADIMAGE1_MEDIA_REQUEST';
export type REMOVE_COMPETITION_ADIMAGE1_MEDIA_REQUEST = typeof REMOVE_COMPETITION_ADIMAGE1_MEDIA_REQUEST;

export const REMOVE_COMPETITION_ADIMAGE1_MEDIA_SUCCESS = 'REMOVE_COMPETITION_ADIMAGE1_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_ADIMAGE1_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_ADIMAGE1_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_ADIMAGE1_MEDIA_FAILURE = 'REMOVE_COMPETITION_ADIMAGE1_MEDIA_FAILURE';
export type REMOVE_COMPETITION_ADIMAGE1_MEDIA_FAILURE = typeof REMOVE_COMPETITION_ADIMAGE1_MEDIA_FAILURE;

export const REMOVE_COMPETITION_ADIMAGE2_MEDIA_REQUEST = 'REMOVE_COMPETITION_ADIMAGE2_MEDIA_REQUEST';
export type REMOVE_COMPETITION_ADIMAGE2_MEDIA_REQUEST = typeof REMOVE_COMPETITION_ADIMAGE2_MEDIA_REQUEST;

export const REMOVE_COMPETITION_ADIMAGE2_MEDIA_SUCCESS = 'REMOVE_COMPETITION_ADIMAGE2_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_ADIMAGE2_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_ADIMAGE2_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_ADIMAGE2_MEDIA_FAILURE = 'REMOVE_COMPETITION_ADIMAGE2_MEDIA_FAILURE';
export type REMOVE_COMPETITION_ADIMAGE2_MEDIA_FAILURE = typeof REMOVE_COMPETITION_ADIMAGE2_MEDIA_FAILURE;

export const REMOVE_COMPETITION_ADIMAGE3_MEDIA_REQUEST = 'REMOVE_COMPETITION_ADIMAGE3_MEDIA_REQUEST';
export type REMOVE_COMPETITION_ADIMAGE3_MEDIA_REQUEST = typeof REMOVE_COMPETITION_ADIMAGE3_MEDIA_REQUEST;

export const REMOVE_COMPETITION_ADIMAGE3_MEDIA_SUCCESS = 'REMOVE_COMPETITION_ADIMAGE3_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_ADIMAGE3_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_ADIMAGE3_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_ADIMAGE3_MEDIA_FAILURE = 'REMOVE_COMPETITION_ADIMAGE3_MEDIA_FAILURE';
export type REMOVE_COMPETITION_ADIMAGE3_MEDIA_FAILURE = typeof REMOVE_COMPETITION_ADIMAGE3_MEDIA_FAILURE;

export const REMOVE_COMPETITION_ADVIDEO1_MEDIA_REQUEST = 'REMOVE_COMPETITION_ADVIDEO1_MEDIA_REQUEST';
export type REMOVE_COMPETITION_ADVIDEO1_MEDIA_REQUEST = typeof REMOVE_COMPETITION_ADVIDEO1_MEDIA_REQUEST;

export const REMOVE_COMPETITION_ADVIDEO1_MEDIA_SUCCESS = 'REMOVE_COMPETITION_ADVIDEO1_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_ADVIDEO1_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_ADVIDEO1_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_ADVIDEO1_MEDIA_FAILURE = 'REMOVE_COMPETITION_ADVIDEO1_MEDIA_FAILURE';
export type REMOVE_COMPETITION_ADVIDEO1_MEDIA_FAILURE = typeof REMOVE_COMPETITION_ADVIDEO1_MEDIA_FAILURE;

export const REMOVE_COMPETITION_ADVIDEO2_MEDIA_REQUEST = 'REMOVE_COMPETITION_ADVIDEO2_MEDIA_REQUEST';
export type REMOVE_COMPETITION_ADVIDEO2_MEDIA_REQUEST = typeof REMOVE_COMPETITION_ADVIDEO2_MEDIA_REQUEST;

export const REMOVE_COMPETITION_ADVIDEO2_MEDIA_SUCCESS = 'REMOVE_COMPETITION_ADVIDEO2_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_ADVIDEO2_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_ADVIDEO2_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_ADVIDEO2_MEDIA_FAILURE = 'REMOVE_COMPETITION_ADVIDEO2_MEDIA_FAILURE';
export type REMOVE_COMPETITION_ADVIDEO2_MEDIA_FAILURE = typeof REMOVE_COMPETITION_ADVIDEO2_MEDIA_FAILURE;

export const REMOVE_COMPETITION_ADVIDEO3_MEDIA_REQUEST = 'REMOVE_COMPETITION_ADVIDEO3_MEDIA_REQUEST';
export type REMOVE_COMPETITION_ADVIDEO3_MEDIA_REQUEST = typeof REMOVE_COMPETITION_ADVIDEO3_MEDIA_REQUEST;

export const REMOVE_COMPETITION_ADVIDEO3_MEDIA_SUCCESS = 'REMOVE_COMPETITION_ADVIDEO3_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_ADVIDEO3_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_ADVIDEO3_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_ADVIDEO3_MEDIA_FAILURE = 'REMOVE_COMPETITION_ADVIDEO3_MEDIA_FAILURE';
export type REMOVE_COMPETITION_ADVIDEO3_MEDIA_FAILURE = typeof REMOVE_COMPETITION_ADVIDEO3_MEDIA_FAILURE;

export const REMOVE_COMPETITION_LOGO_MEDIA_REQUEST = 'REMOVE_COMPETITION_LOGO_MEDIA_REQUEST';
export type REMOVE_COMPETITION_LOGO_MEDIA_REQUEST = typeof REMOVE_COMPETITION_LOGO_MEDIA_REQUEST;

export const REMOVE_COMPETITION_LOGO_MEDIA_SUCCESS = 'REMOVE_COMPETITION_LOGO_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_LOGO_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_LOGO_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_LOGO_MEDIA_FAILURE = 'REMOVE_COMPETITION_LOGO_MEDIA_FAILURE';
export type REMOVE_COMPETITION_LOGO_MEDIA_FAILURE = typeof REMOVE_COMPETITION_LOGO_MEDIA_FAILURE;

export const REMOVE_COMPETITION_INTROCOVER_MEDIA_REQUEST = 'REMOVE_COMPETITION_INTROCOVER_MEDIA_REQUEST';
export type REMOVE_COMPETITION_INTROCOVER_MEDIA_REQUEST = typeof REMOVE_COMPETITION_INTROCOVER_MEDIA_REQUEST;

export const REMOVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS = 'REMOVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_INTROCOVER_MEDIA_FAILURE = 'REMOVE_COMPETITION_INTROCOVER_MEDIA_FAILURE';
export type REMOVE_COMPETITION_INTROCOVER_MEDIA_FAILURE = typeof REMOVE_COMPETITION_INTROCOVER_MEDIA_FAILURE;

export const REMOVE_COMPETITION_WATERMARK_MEDIA_REQUEST = 'REMOVE_COMPETITION_WATERMARK_MEDIA_REQUEST';
export type REMOVE_COMPETITION_WATERMARK_MEDIA_REQUEST = typeof REMOVE_COMPETITION_WATERMARK_MEDIA_REQUEST;

export const REMOVE_COMPETITION_WATERMARK_MEDIA_SUCCESS = 'REMOVE_COMPETITION_WATERMARK_MEDIA_SUCCESS';
export type REMOVE_COMPETITION_WATERMARK_MEDIA_SUCCESS = typeof REMOVE_COMPETITION_WATERMARK_MEDIA_SUCCESS;

export const REMOVE_COMPETITION_WATERMARK_MEDIA_FAILURE = 'REMOVE_COMPETITION_WATERMARK_MEDIA_FAILURE';
export type REMOVE_COMPETITION_WATERMARK_MEDIA_FAILURE = typeof REMOVE_COMPETITION_WATERMARK_MEDIA_FAILURE;

export const ACCEPT_COMPETITION_TERMS_REQUEST = 'ACCEPT_COMPETITION_TERMS_REQUEST';
export type ACCEPT_COMPETITION_TERMS_REQUEST = typeof ACCEPT_COMPETITION_TERMS_REQUEST;

export const ACCEPT_COMPETITION_TERMS_SUCCESS = 'ACCEPT_COMPETITION_TERMS_SUCCESS';
export type ACCEPT_COMPETITION_TERMS_SUCCESS = typeof ACCEPT_COMPETITION_TERMS_SUCCESS;

export const ACCEPT_COMPETITION_TERMS_FAILURE = 'ACCEPT_COMPETITION_TERMS_FAILURE';
export type ACCEPT_COMPETITION_TERMS_FAILURE = typeof ACCEPT_COMPETITION_TERMS_FAILURE;

export const SAVE_COMPETITION_TYPE_REQUEST = 'SAVE_COMPETITION_TYPE_REQUEST';
export type SAVE_COMPETITION_TYPE_REQUEST = typeof SAVE_COMPETITION_TYPE_REQUEST;

export const SAVE_COMPETITION_TYPE_SUCCESS = 'SAVE_COMPETITION_TYPE_SUCCESS';
export type SAVE_COMPETITION_TYPE_SUCCESS = typeof SAVE_COMPETITION_TYPE_SUCCESS;

export const SAVE_COMPETITION_TYPE_FAILURE = 'SAVE_COMPETITION_TYPE_FAILURE';
export type SAVE_COMPETITION_TYPE_FAILURE = typeof SAVE_COMPETITION_TYPE_FAILURE;

export const PUBLISH_COMPETITION_REQUEST = 'PUBLISH_COMPETITION_REQUEST';
export type PUBLISH_COMPETITION_REQUEST = typeof PUBLISH_COMPETITION_REQUEST;

export const PUBLISH_COMPETITION_SUCCESS = 'PUBLISH_COMPETITION_SUCCESS';
export type PUBLISH_COMPETITION_SUCCESS = typeof PUBLISH_COMPETITION_SUCCESS;

export const PUBLISH_COMPETITION_FAILURE = 'PUBLISH_COMPETITION_FAILURE';
export type PUBLISH_COMPETITION_FAILURE = typeof PUBLISH_COMPETITION_FAILURE;

export const UNPUBLISH_COMPETITION_REQUEST = 'UNPUBLISH_COMPETITION_REQUEST';
export type UNPUBLISH_COMPETITION_REQUEST = typeof UNPUBLISH_COMPETITION_REQUEST;

export const UNPUBLISH_COMPETITION_SUCCESS = 'UNPUBLISH_COMPETITION_SUCCESS';
export type UNPUBLISH_COMPETITION_SUCCESS = typeof UNPUBLISH_COMPETITION_SUCCESS;

export const UNPUBLISH_COMPETITION_FAILURE = 'UNPUBLISH_COMPETITION_FAILURE';
export type UNPUBLISH_COMPETITION_FAILURE = typeof UNPUBLISH_COMPETITION_FAILURE;

export const DUPLICATE_COMPETITION_REQUEST = 'DUPLICATE_COMPETITION_REQUEST';
export type DUPLICATE_COMPETITION_REQUEST = typeof DUPLICATE_COMPETITION_REQUEST;

export const DUPLICATE_COMPETITION_SUCCESS = 'DUPLICATE_COMPETITION_SUCCESS';
export type DUPLICATE_COMPETITION_SUCCESS = typeof DUPLICATE_COMPETITION_SUCCESS;

export const DUPLICATE_COMPETITION_FAILURE = 'DUPLICATE_COMPETITION_FAILURE';
export type DUPLICATE_COMPETITION_FAILURE = typeof DUPLICATE_COMPETITION_FAILURE;

export const APPROVE_COMPETITION_ENTRY_REQUEST = 'APPROVE_COMPETITION_ENTRY_REQUEST';
export type APPROVE_COMPETITION_ENTRY_REQUEST = typeof APPROVE_COMPETITION_ENTRY_REQUEST;

export const APPROVE_COMPETITION_ENTRY_SUCCESS = 'APPROVE_COMPETITION_ENTRY_SUCCESS';
export type APPROVE_COMPETITION_ENTRY_SUCCESS = typeof APPROVE_COMPETITION_ENTRY_SUCCESS;

export const APPROVE_COMPETITION_ENTRY_FAILURE = 'APPROVE_COMPETITION_ENTRY_FAILURE';
export type APPROVE_COMPETITION_ENTRY_FAILURE = typeof APPROVE_COMPETITION_ENTRY_FAILURE;

export const REJECT_COMPETITION_ENTRY_REQUEST = 'REJECT_COMPETITION_ENTRY_REQUEST';
export type REJECT_COMPETITION_ENTRY_REQUEST = typeof REJECT_COMPETITION_ENTRY_REQUEST;

export const REJECT_COMPETITION_ENTRY_SUCCESS = 'REJECT_COMPETITION_ENTRY_SUCCESS';
export type REJECT_COMPETITION_ENTRY_SUCCESS = typeof REJECT_COMPETITION_ENTRY_SUCCESS;

export const REJECT_COMPETITION_ENTRY_FAILURE = 'REJECT_COMPETITION_ENTRY_FAILURE';
export type REJECT_COMPETITION_ENTRY_FAILURE = typeof REJECT_COMPETITION_ENTRY_FAILURE;

export const APPROVE_COMPETITION_STAGE_REQUEST = 'APPROVE_COMPETITION_STAGE_REQUEST';
export type APPROVE_COMPETITION_STAGE_REQUEST = typeof APPROVE_COMPETITION_STAGE_REQUEST;

export const APPROVE_COMPETITION_STAGE_SUCCESS = 'APPROVE_COMPETITION_STAGE_SUCCESS';
export type APPROVE_COMPETITION_STAGE_SUCCESS = typeof APPROVE_COMPETITION_STAGE_SUCCESS;

export const APPROVE_COMPETITION_STAGE_FAILURE = 'APPROVE_COMPETITION_STAGE_FAILURE';
export type APPROVE_COMPETITION_STAGE_FAILURE = typeof APPROVE_COMPETITION_STAGE_FAILURE;

export const FETCH_PROPOSED_ENTRY_REQUEST = 'FETCH_PROPOSED_ENTRY_REQUEST';
export type FETCH_PROPOSED_ENTRY_REQUEST = typeof FETCH_PROPOSED_ENTRY_REQUEST;

export const FETCH_PROPOSED_ENTRY_SUCCESS = 'FETCH_PROPOSED_ENTRY_SUCCESS';
export type FETCH_PROPOSED_ENTRY_SUCCESS = typeof FETCH_PROPOSED_ENTRY_SUCCESS;

export const FETCH_PROPOSED_ENTRY_FAILURE = 'FETCH_PROPOSED_ENTRY_FAILURE';
export type FETCH_PROPOSED_ENTRY_FAILURE = typeof FETCH_PROPOSED_ENTRY_FAILURE;

export const UNVERIFY_COMPETITION_ENTRY_REQUEST = 'UNVERIFY_COMPETITION_ENTRY_REQUEST';
export type UNVERIFY_COMPETITION_ENTRY_REQUEST = typeof UNVERIFY_COMPETITION_ENTRY_REQUEST;

export const UNVERIFY_COMPETITION_ENTRY_SUCCESS = 'UNVERIFY_COMPETITION_ENTRY_SUCCESS';
export type UNVERIFY_COMPETITION_ENTRY_SUCCESS = typeof UNVERIFY_COMPETITION_ENTRY_SUCCESS;

export const UNVERIFY_COMPETITION_ENTRY_FAILURE = 'UNVERIFY_COMPETITION_ENTRY_FAILURE';
export type UNVERIFY_COMPETITION_ENTRY_FAILURE = typeof UNVERIFY_COMPETITION_ENTRY_FAILURE;

export const SET_COMMENT_POST_REQUEST = 'SET_COMMENT_POST_REQUEST';
export type SET_COMMENT_POST_REQUEST = typeof SET_COMMENT_POST_REQUEST;

export const SET_COMMENT_POST_SUCCESS = 'SET_COMMENT_POST_SUCCESS';
export type SET_COMMENT_POST_SUCCESS = typeof SET_COMMENT_POST_SUCCESS;

export const SET_COMMENT_POST_FAILURE = 'SET_COMMENT_POST_FAILURE';
export type SET_COMMENT_POST_FAILURE = typeof SET_COMMENT_POST_FAILURE;

export const DELETE_ENTRIES_REQUEST = 'DELETE_ENTRIES_REQUEST';
export type DELETE_ENTRIES_REQUEST = typeof DELETE_ENTRIES_REQUEST;

export const DELETE_ENTRIES_SUCCESS = 'DELETE_ENTRIES_SUCCESS';
export type DELETE_ENTRIES_SUCCESS = typeof DELETE_ENTRIES_SUCCESS;

export const DELETE_ENTRIES_FAILURE = 'DELETE_ENTRIES_FAILURE';
export type DELETE_ENTRIES_FAILURE = typeof DELETE_ENTRIES_FAILURE;

export const REMOVE_FOLDER_FROM_STORY_REQUEST = 'REMOVE_FOLDER_FROM_STORY_REQUEST';
export type REMOVE_FOLDER_FROM_STORY_REQUEST = typeof REMOVE_FOLDER_FROM_STORY_REQUEST;

export const REMOVE_FOLDER_FROM_STORY_SUCCESS = 'REMOVE_FOLDER_FROM_STORY_SUCCESS';
export type REMOVE_FOLDER_FROM_STORY_SUCCESS = typeof REMOVE_FOLDER_FROM_STORY_SUCCESS;

export const REMOVE_FOLDER_FROM_STORY_FAILURE = 'REMOVE_FOLDER_FROM_STORY_FAILURE';
export type REMOVE_FOLDER_FROM_STORY_FAILURE = typeof REMOVE_FOLDER_FROM_STORY_FAILURE;

export const ADD_FOLDER_TO_STORY_REQUEST = 'ADD_FOLDER_TO_STORY_REQUEST';
export type ADD_FOLDER_TO_STORY_REQUEST = typeof ADD_FOLDER_TO_STORY_REQUEST;

export const ADD_FOLDER_TO_STORY_SUCCESS = 'ADD_FOLDER_TO_STORY_SUCCESS';
export type ADD_FOLDER_TO_STORY_SUCCESS = typeof ADD_FOLDER_TO_STORY_SUCCESS;

export const ADD_FOLDER_TO_STORY_FAILURE = 'ADD_FOLDER_TO_STORY_FAILURE';
export type ADD_FOLDER_TO_STORY_FAILURE = typeof ADD_FOLDER_TO_STORY_FAILURE;

export const SET_FOLDER_SETTINGS_REQUEST = 'SET_FOLDER_SETTINGS_REQUEST';
export type SET_FOLDER_SETTINGS_REQUEST = typeof SET_FOLDER_SETTINGS_REQUEST;

export const SET_FOLDER_SETTINGS_SUCCESS = 'SET_FOLDER_SETTINGS_SUCCESS';
export type SET_FOLDER_SETTINGS_SUCCESS = typeof SET_FOLDER_SETTINGS_SUCCESS;

export const SET_FOLDER_SETTINGS_FAILURE = 'SET_FOLDER_SETTINGS_FAILURE';
export type SET_FOLDER_SETTINGS_FAILURE = typeof SET_FOLDER_SETTINGS_FAILURE;

export const SET_FOLDER_META_REQUEST = 'SET_FOLDER_META_REQUEST';
export type SET_FOLDER_META_REQUEST = typeof SET_FOLDER_META_REQUEST;

export const SET_FOLDER_META_SUCCESS = 'SET_FOLDER_META_SUCCESS';
export type SET_FOLDER_META_SUCCESS = typeof SET_FOLDER_META_SUCCESS;

export const SET_FOLDER_META_FAILURE = 'SET_FOLDER_META_FAILURE';
export type SET_FOLDER_META_FAILURE = typeof SET_FOLDER_META_FAILURE;

export const DELETE_FOLDER_REQUEST = 'DELETE_FOLDER_REQUEST';
export type DELETE_FOLDER_REQUEST = typeof DELETE_FOLDER_REQUEST;

export const DELETE_FOLDER_SUCCESS = 'DELETE_FOLDER_SUCCESS';
export type DELETE_FOLDER_SUCCESS = typeof DELETE_FOLDER_SUCCESS;

export const DELETE_FOLDER_FAILURE = 'DELETE_FOLDER_FAILURE';
export type DELETE_FOLDER_FAILURE = typeof DELETE_FOLDER_FAILURE;

export const PUBLISH_BOARD_REQUEST = 'PUBLISH_BOARD_REQUEST';
export type PUBLISH_BOARD_REQUEST = typeof PUBLISH_BOARD_REQUEST;

export const PUBLISH_BOARD_SUCCESS = 'PUBLISH_BOARD_SUCCESS';
export type PUBLISH_BOARD_SUCCESS = typeof PUBLISH_BOARD_SUCCESS;

export const PUBLISH_BOARD_FAILURE = 'PUBLISH_BOARD_FAILURE';
export type PUBLISH_BOARD_FAILURE = typeof PUBLISH_BOARD_FAILURE;

export const REQUIRE_BOARD_WORDS_REQUEST = 'REQUIRE_BOARD_WORDS_REQUEST';
export type REQUIRE_BOARD_WORDS_REQUEST = typeof REQUIRE_BOARD_WORDS_REQUEST;

export const REQUIRE_BOARD_WORDS_SUCCESS = 'REQUIRE_BOARD_WORDS_SUCCESS';
export type REQUIRE_BOARD_WORDS_SUCCESS = typeof REQUIRE_BOARD_WORDS_SUCCESS;

export const REQUIRE_BOARD_WORDS_FAILURE = 'REQUIRE_BOARD_WORDS_FAILURE';
export type REQUIRE_BOARD_WORDS_FAILURE = typeof REQUIRE_BOARD_WORDS_FAILURE;

export const REQUIRE_COMPETITION_WORDS_REQUEST = 'REQUIRE_COMPETITION_WORDS_REQUEST';
export type REQUIRE_COMPETITION_WORDS_REQUEST = typeof REQUIRE_COMPETITION_WORDS_REQUEST;

export const REQUIRE_COMPETITION_WORDS_SUCCESS = 'REQUIRE_COMPETITION_WORDS_SUCCESS';
export type REQUIRE_COMPETITION_WORDS_SUCCESS = typeof REQUIRE_COMPETITION_WORDS_SUCCESS;

export const REQUIRE_COMPETITION_WORDS_FAILURE = 'REQUIRE_COMPETITION_WORDS_FAILURE';
export type REQUIRE_COMPETITION_WORDS_FAILURE = typeof REQUIRE_COMPETITION_WORDS_FAILURE;

export const REMOVE_REQUIRED_BOARD_WORD_REQUEST = 'REMOVE_REQUIRED_BOARD_WORD_REQUEST';
export type REMOVE_REQUIRED_BOARD_WORD_REQUEST = typeof REMOVE_REQUIRED_BOARD_WORD_REQUEST;

export const REMOVE_REQUIRED_BOARD_WORD_SUCCESS = 'REMOVE_REQUIRED_BOARD_WORD_SUCCESS';
export type REMOVE_REQUIRED_BOARD_WORD_SUCCESS = typeof REMOVE_REQUIRED_BOARD_WORD_SUCCESS;

export const REMOVE_REQUIRED_BOARD_WORD_FAILURE = 'REMOVE_REQUIRED_BOARD_WORD_FAILURE';
export type REMOVE_REQUIRED_BOARD_WORD_FAILURE = typeof REMOVE_REQUIRED_BOARD_WORD_FAILURE;

export const REMOVE_REQUIRED_COMPETITION_WORD_REQUEST = 'REMOVE_REQUIRED_COMPETITION_WORD_REQUEST';
export type REMOVE_REQUIRED_COMPETITION_WORD_REQUEST = typeof REMOVE_REQUIRED_COMPETITION_WORD_REQUEST;

export const REMOVE_REQUIRED_COMPETITION_WORD_SUCCESS = 'REMOVE_REQUIRED_COMPETITION_WORD_SUCCESS';
export type REMOVE_REQUIRED_COMPETITION_WORD_SUCCESS = typeof REMOVE_REQUIRED_COMPETITION_WORD_SUCCESS;

export const REMOVE_REQUIRED_COMPETITION_WORD_FAILURE = 'REMOVE_REQUIRED_COMPETITION_WORD_FAILURE';
export type REMOVE_REQUIRED_COMPETITION_WORD_FAILURE = typeof REMOVE_REQUIRED_COMPETITION_WORD_FAILURE;

export const FORCE_ADVANCE_ENTRY_REQUEST = 'FORCE_ADVANCE_ENTRY_REQUEST';
export type FORCE_ADVANCE_ENTRY_REQUEST = typeof FORCE_ADVANCE_ENTRY_REQUEST;

export const FORCE_ADVANCE_ENTRY_SUCCESS = 'FORCE_ADVANCE_ENTRY_SUCCESS';
export type FORCE_ADVANCE_ENTRY_SUCCESS = typeof FORCE_ADVANCE_ENTRY_SUCCESS;

export const FORCE_ADVANCE_ENTRY_FAILURE = 'FORCE_ADVANCE_ENTRY_FAILURE';
export type FORCE_ADVANCE_ENTRY_FAILURE = typeof FORCE_ADVANCE_ENTRY_FAILURE;

export const FORCE_REMOVE_ENTRY_STAGE_REQUEST = 'FORCE_REMOVE_ENTRY_STAGE_REQUEST';
export type FORCE_REMOVE_ENTRY_STAGE_REQUEST = typeof FORCE_REMOVE_ENTRY_STAGE_REQUEST;

export const FORCE_REMOVE_ENTRY_STAGE_SUCCESS = 'FORCE_REMOVE_ENTRY_STAGE_SUCCESS';
export type FORCE_REMOVE_ENTRY_STAGE_SUCCESS = typeof FORCE_REMOVE_ENTRY_STAGE_SUCCESS;

export const FORCE_REMOVE_ENTRY_STAGE_FAILURE = 'FORCE_REMOVE_ENTRY_STAGE_FAILURE';
export type FORCE_REMOVE_ENTRY_STAGE_FAILURE = typeof FORCE_REMOVE_ENTRY_STAGE_FAILURE;

export const PREVIEW_ADVANCE_COMPETITION_REQUEST = 'PREVIEW_ADVANCE_COMPETITION_REQUEST';
export type PREVIEW_ADVANCE_COMPETITION_REQUEST = typeof PREVIEW_ADVANCE_COMPETITION_REQUEST;

export const PREVIEW_ADVANCE_COMPETITION_SUCCESS = 'PREVIEW_ADVANCE_COMPETITION_SUCCESS';
export type PREVIEW_ADVANCE_COMPETITION_SUCCESS = typeof PREVIEW_ADVANCE_COMPETITION_SUCCESS;

export const PREVIEW_ADVANCE_COMPETITION_FAILURE = 'PREVIEW_ADVANCE_COMPETITION_FAILURE';
export type PREVIEW_ADVANCE_COMPETITION_FAILURE = typeof PREVIEW_ADVANCE_COMPETITION_FAILURE;

export const PREVIEW_SEED_COMPETITION_REQUEST = 'PREVIEW_SEED_COMPETITION_REQUEST';
export type PREVIEW_SEED_COMPETITION_REQUEST = typeof PREVIEW_SEED_COMPETITION_REQUEST;

export const PREVIEW_SEED_COMPETITION_SUCCESS = 'PREVIEW_SEED_COMPETITION_SUCCESS';
export type PREVIEW_SEED_COMPETITION_SUCCESS = typeof PREVIEW_SEED_COMPETITION_SUCCESS;

export const PREVIEW_SEED_COMPETITION_FAILURE = 'PREVIEW_SEED_COMPETITION_FAILURE';
export type PREVIEW_SEED_COMPETITION_FAILURE = typeof PREVIEW_SEED_COMPETITION_FAILURE;

export const UPDATE_STORY_REQUEST = 'UPDATE_STORY_REQUEST';
export type UPDATE_STORY_REQUEST = typeof UPDATE_STORY_REQUEST;

export const UPDATE_STORY_SUCCESS = 'UPDATE_STORY_SUCCESS';
export type UPDATE_STORY_SUCCESS = typeof UPDATE_STORY_SUCCESS;

export const UPDATE_STORY_FAILURE = 'UPDATE_STORY_FAILURE';
export type UPDATE_STORY_FAILURE = typeof UPDATE_STORY_FAILURE;

export const REMOVE_ENTRY_MEDIA_REQUEST = 'REMOVE_ENTRY_MEDIA_REQUEST';
export type REMOVE_ENTRY_MEDIA_REQUEST = typeof REMOVE_ENTRY_MEDIA_REQUEST;

export const REMOVE_ENTRY_MEDIA_SUCCESS = 'REMOVE_ENTRY_MEDIA_SUCCESS';
export type REMOVE_ENTRY_MEDIA_SUCCESS = typeof REMOVE_ENTRY_MEDIA_SUCCESS;

export const REMOVE_ENTRY_MEDIA_FAILURE = 'REMOVE_ENTRY_MEDIA_FAILURE';
export type REMOVE_ENTRY_MEDIA_FAILURE = typeof REMOVE_ENTRY_MEDIA_FAILURE;

export const REMOVE_ENTRY_MEDIA_THUMBNAIL_REQUEST = 'REMOVE_ENTRY_MEDIA_THUMBNAIL_REQUEST';
export type REMOVE_ENTRY_MEDIA_THUMBNAIL_REQUEST = typeof REMOVE_ENTRY_MEDIA_THUMBNAIL_REQUEST;

export const REMOVE_ENTRY_MEDIA_THUMBNAIL_SUCCESS = 'REMOVE_ENTRY_MEDIA_THUMBNAIL_SUCCESS';
export type REMOVE_ENTRY_MEDIA_THUMBNAIL_SUCCESS = typeof REMOVE_ENTRY_MEDIA_THUMBNAIL_SUCCESS;

export const REMOVE_ENTRY_MEDIA_THUMBNAIL_FAILURE = 'REMOVE_ENTRY_MEDIA_THUMBNAIL_FAILURE';
export type REMOVE_ENTRY_MEDIA_THUMBNAIL_FAILURE = typeof REMOVE_ENTRY_MEDIA_THUMBNAIL_FAILURE;

export const UPDATE_ENTRY_MEDIA_THUMBNAIL_REQUEST = 'UPDATE_ENTRY_MEDIA_THUMBNAIL_REQUEST';
export type UPDATE_ENTRY_MEDIA_THUMBNAIL_REQUEST = typeof UPDATE_ENTRY_MEDIA_THUMBNAIL_REQUEST;

export const UPDATE_ENTRY_MEDIA_THUMBNAIL_SUCCESS = 'UPDATE_ENTRY_MEDIA_THUMBNAIL_SUCCESS';
export type UPDATE_ENTRY_MEDIA_THUMBNAIL_SUCCESS = typeof UPDATE_ENTRY_MEDIA_THUMBNAIL_SUCCESS;

export const UPDATE_ENTRY_MEDIA_THUMBNAIL_FAILURE = 'UPDATE_ENTRY_MEDIA_THUMBNAIL_FAILURE';
export type UPDATE_ENTRY_MEDIA_THUMBNAIL_FAILURE = typeof UPDATE_ENTRY_MEDIA_THUMBNAIL_FAILURE;

export const UPDATE_ENTRY_MEDIA_REQUEST = 'UPDATE_ENTRY_MEDIA_REQUEST';
export type UPDATE_ENTRY_MEDIA_REQUEST = typeof UPDATE_ENTRY_MEDIA_REQUEST;

export const UPDATE_ENTRY_MEDIA_SUCCESS = 'UPDATE_ENTRY_MEDIA_SUCCESS';
export type UPDATE_ENTRY_MEDIA_SUCCESS = typeof UPDATE_ENTRY_MEDIA_SUCCESS;

export const UPDATE_ENTRY_MEDIA_FAILURE = 'UPDATE_ENTRY_MEDIA_FAILURE';
export type UPDATE_ENTRY_MEDIA_FAILURE = typeof UPDATE_ENTRY_MEDIA_FAILURE;

export const CREATE_ENTRY_REQUEST = 'CREATE_ENTRY_REQUEST';
export type CREATE_ENTRY_REQUEST = typeof CREATE_ENTRY_REQUEST;

export const CREATE_ENTRY_SUCCESS = 'CREATE_ENTRY_SUCCESS';
export type CREATE_ENTRY_SUCCESS = typeof CREATE_ENTRY_SUCCESS;

export const CREATE_ENTRY_FAILURE = 'CREATE_ENTRY_FAILURE';
export type CREATE_ENTRY_FAILURE = typeof CREATE_ENTRY_FAILURE;

export const CLEAR_ENTRY_PROCESSING = 'CLEAR_ENTRY_PROCESSING';
export type CLEAR_ENTRY_PROCESSING = typeof CLEAR_ENTRY_PROCESSING;

export const EXPORT_COMPETITION_BOARD_REQUEST = 'EXPORT_COMPETITION_BOARD_REQUEST';
export type EXPORT_COMPETITION_BOARD_REQUEST = typeof EXPORT_COMPETITION_BOARD_REQUEST;

export const EXPORT_COMPETITION_BOARD_SUCCESS = 'EXPORT_COMPETITION_BOARD_SUCCESS';
export type EXPORT_COMPETITION_BOARD_SUCCESS = typeof EXPORT_COMPETITION_BOARD_SUCCESS;

export const EXPORT_COMPETITION_BOARD_FAILURE = 'EXPORT_COMPETITION_BOARD_FAILURE';
export type EXPORT_COMPETITION_BOARD_FAILURE = typeof EXPORT_COMPETITION_BOARD_FAILURE;

export const EntityConstFactory = {
  [EntityTypes.BOARD]: {
    createEntity: CREATE_BOARD_REQUEST,
    getEntity: GET_BOARD_REQUEST,
    updateEntity: UPDATE_BOARD_REQUEST,
    deleteEntity: DELETE_BOARD_REQUEST,
    getMemberList: GET_BOARD_MEMBER_LIST_REQUEST,
    updateEntityMemberRole: UPDATE_BOARD_MEMBER_ROLE_REQUEST,
    addEntityMember: {
      request: INVITE_BOARD_MEMBERS_REQUEST,
      success: INVITE_BOARD_MEMBERS_SUCCESS,
      failure: INVITE_BOARD_MEMBERS_FAILURE,
    },
    removeEntityMember: REMOVE_BOARD_MEMBER_REQUEST,
    updateEmbedUrl: UPDATE_BOARD_EMBED_URL_REQUEST,
    getEntityMeta: GET_BOARD_META_REQUEST,
    updateShareMessaging: UPDATE_BOARD_SHARE_MESSAGING_REQUEST,
    toggleWordBlacklist: TOGGLE_BOARD_WORD_BLACKLIST_REQUEST,
    blockWords: BLOCK_BOARD_WORDS_REQUEST,
    unblockWords: UNBLOCK_BOARD_WORDS_REQUEST,
    setEntityMeta: SET_BOARD_META_REQUEST,
    entityBlockUsername: BOARD_BLOCK_USERNAME,
    entityUnblockUsername: BOARD_UNBLOCK_USERNAME,
    requireWords: REQUIRE_BOARD_WORDS_REQUEST,
    removeRequiredWord: REMOVE_REQUIRED_BOARD_WORD_REQUEST,
  },
  [EntityTypes.COMPETITION]: {
    createEntity: CREATE_COMPETITION_REQUEST,
    getEntity: GET_COMPETITION_REQUEST,
    updateEntity: UPDATE_COMPETITION_REQUEST,
    deleteEntity: DELETE_COMPETITION_REQUEST,
    getMemberList: GET_COMPETITION_MEMBER_LIST_REQUEST,
    updateEntityMemberRole: UPDATE_COMPETITION_MEMBER_ROLE_REQUEST,
    addEntityMember: {
      request: INVITE_COMPETITION_MEMBERS_REQUEST,
      success: INVITE_COMPETITION_MEMBERS_SUCCESS,
      failure: INVITE_COMPETITION_MEMBERS_FAILURE,
    },
    removeEntityMember: REMOVE_COMPETITION_MEMBER_REQUEST,
    updateEmbedUrl: UPDATE_COMPETITION_EMBED_URL_REQUEST,
    getEntityMeta: GET_COMPETITION_META_REQUEST,
    updateShareMessaging: UPDATE_COMPETITION_SHARE_MESSAGING_REQUEST,
    updateCustomCSS: UPDATE_CUSTOM_CSS_REQUEST,
    toggleWordBlacklist: TOGGLE_COMPETITION_WORD_BLACKLIST_REQUEST,
    blockWords: BLOCK_COMPETITION_WORDS_REQUEST,
    unblockWords: UNBLOCK_COMPETITION_WORDS_REQUEST,
    setEntityMeta: SET_COMPETITION_META_REQUEST,
    entityBlockUsername: COMPETITION_BLOCK_USERNAME,
    entityUnblockUsername: COMPETITION_UNBLOCK_USERNAME,
    duplicateEntity: DUPLICATE_COMPETITION_REQUEST,
    requireWords: REQUIRE_COMPETITION_WORDS_REQUEST,
    removeRequiredWord: REMOVE_REQUIRED_COMPETITION_WORD_REQUEST,
    exportToBoard: EXPORT_COMPETITION_BOARD_REQUEST,
  },
};
